import React, { Component } from "react";
import {
    checkEmailAvailability,
    checkEmailAvailabilityNotIn,
    request,
    getEczanelerByIlce,
    getIlceler,
    getRegions,
    getEczanelerByRegion
} from "../../util/APIUtils";
import {
    deepCopyObject,
    filterCities,
    getCitySubdivisions,
    showAxiosError,
    trimObject,
} from "../../util/Helpers";
import { Button, DatePicker, Form, input, Switch } from "antd";
import Select from "../../local_node_modules/react-select";
import Alert from "react-s-alert";
import { validateComponent, validateField } from "../../common/validation";
import moment from "moment";
import {
    Label,
    Modal,
    ModalBody,
    ModalHeader,
    UncontrolledTooltip,
} from "reactstrap";
import "./MemberList.css";
import { API_BASE_URL } from "../../constants";
import LoadingIndicator from "../../common/LoadingIndicator";
import Uploader2 from "../../components/Uploader/Uploader2";
import "react-datetime/css/react-datetime.css";
import _ from "lodash";
import InActivateMemberModal from "./InActivateMemberModal";
import emailMask from "text-mask-addons/dist/emailMask";
import MaskedInput from "react-text-mask/dist/reactTextMask";
import { Map, Marker, TileLayer } from "react-leaflet";
import MemberPharmacyModal from "./MemberPharmacyModal";

const { TextArea } = input;

class MemberForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            error: {},
            emailAvailabilityError: {},
            isAddPharmacyModalOpen: false,
            createdPharmacy: null,
            page: 0,
            size: 10,
            manual: false,
            loading: false,
            isLoading: false,
            authRoles: [],
            fieldsDisabled: false,
            citySelectionDisabled: false,
            mode: this.props.mode,
            outstandingAccruals: [],
            // isPassiveAllowed: false,
            inActivateMemberModal: false,
            isPreviouslyInactivated: false,
            townOptions: [],
            regionOptions: [],
            pharmacyOptions: [],
            memberInfo: {
                id: null,
                ad: "",
                soyad: "",
                eskiSoyad: "",
                tcKimlikNo: "",
                dogumTarihi: null,
                kimlikTipi: "",
                cuzdanKimlikSeriNo: "",
                kayitNo: "",
                kimlikSonGecerlilikTarihi: null,
                babaAdi: "",
                anaAdi: "",
                dogumYeri: "",
                medeniHali: "",
                kanGrubu: "",
                eposta: "",
                evTel: "",
                gsmTel: "",
                isTel: "",
                isAdres: "",
                ikametAdres: "",
                odaKayitTarihi: "",
                odaSicilNo: "",
                universite: "",
                belgeTuru: "",
                mezuniyetTarihi: null,
                diplomaNo: "",
                gozRuhTarih: null,
                gozRuhNo: "",
                gozRuhKurum: "",
                ruhsatTarihi: null,
                ruhsatNo: "",
                vergiDairesiAd: "",
                vergiNo: "",
                fotoFile: "",
                kimlikCuzdanFile: "",
                adliSicilFile: "",
                ruhsatnameFile: "",
                diplomaFile: "",
                ikametgahFile: "",
                fotoThumbFile: "",
                calismaBelgesiFile: "",
                uyelikDurdurmaDilekceFile: "",
                taahhutBelgesiFile: "",
                taahhutBelgesiThumbFile: "",
                kayitDilekceFile: "",
                ozgecmisFile: "",
                imzaSirküsFile: "",
                taahhutBelgesiPath: "",
                kimlikCuzdanThumbFile: "",
                adliSicilThumbFile: "",
                ruhsatnameThumbFile: "",
                diplomaThumbFile: "",
                ikametgahThumbFile: "",
                calismaBelgesiThumbFile: "",
                uyelikDurdurmaDilekceThumbFile: "",
                kayitDilekceThumbFile: "",
                ozgecmisThumbFile: "",
                imzaSirküsThumbFile: "",
                fotoPath: "",
                kimlikCuzdanPath: "",
                adliSicilPath: "",
                ruhsatnamePath: "",
                diplomaPath: "",
                ikametgahPath: "",
                calismaBelgesiPath: "",
                uyelikDurdurmaDilekcePath: "",
                kayitDilekcePath: "",
                ozgecmisPath: "",
                imzaSirküsPath: "",
                basvuruDurumu: "",
                uyeTipi: "",
                uyeEczaneAcilis: "",
                basvuruReddedilmeSebebi: "",
                ruhsatAktif: true,
                uyelikAktif: true,
                borcuVar: false,
                uyeCalisiyor: true,
                taahhut: false,
                kendiIsyeri: false,
                mesulMudur: false,
                kamuPersoneli: false,
                eczaci: false,
                temsilci: false,
                unemployed: false,
                uyelikPasiflikNedeni: "",
                user_id: "",
                username: "",
                email: "",
                cinsiyet: "",
                muesseseAdi: "",
                muesseseSahibi: "",
                isTransferred: false,
                calismaBelgeli: false,
                townSelection: null,
                pharmacySelection: null,
                city: {
                    id: null,
                    plakaKod: null,
                    ad: null,
                    oda: {
                        id: null,
                        ad: null,
                        adres: null,
                        telefonNo: null,
                        email: null,
                        webSitesiURL: null,
                        kurulusKararNo: null,
                    },
                },
                addressList: [
                    {
                        id: null,
                        addressType: "PERMANENT",
                        addressString: null,
                        semt: null,
                        cityId: 63,
                        citysubdivisionId: null,
                        memberId: null,
                    },
                    {
                        id: null,
                        addressType: "WORK",
                        addressString: null,
                        semt: null,
                        cityId: 63,
                        citysubdivisionId: null,
                        memberId: null,
                    },
                ],
                newPharmacy: null
            },
            fileInfo: {
                kimlikCuzdanFileName: "kimlikCuzdanFile",
                adliSicilFileName: "adliSicilFile",
                ruhsatnameFileName: "ruhsatnameFile",
                diplomaFileName: "diplomaFile",
                ikametgahFileName: "ikametgahFile",
                fotoFileName: "fotoFile",
                calismaBelgesiFileName: "calismaBelgesiFile",
                uyelikDurdurmaDilekceFileName: "uyelikDurdurmaDilekceFile",
                taahhutBelgesiFileName: "taahhutBelgesiFile",
                kayitDilekceFileName: "kayitDilekceFile",
                ozgecmisFileName: "ozgecmisFile",
                imzaSirüsFileName: "imzaSirüsFile",
            },
            permanentAdrsCities: null,
            workAdrsCities: null,
            permanentAdrsCitySubdivisions: null,
            workAdrsCitySubdivisions: null,
            deepCopyObject: false,
        };

        this.saveMember = this.saveMember.bind(this);
        this.cancelProcess = this.cancelProcess.bind(this);
        this.onChangeMember = this.onChangeMember.bind(this);
        this.validateClass = this.validateClass.bind(this);
        this.validateMessage = this.validateMessage.bind(this);
        this.validateField = this.validateField.bind(this);
        this.onCityInfoChange = this.onCityInfoChange.bind(this);
        this.onChangeCheck = this.onChangeCheck.bind(this);
        this.getUserInfo = this.getUserInfo.bind(this);
        this.validateEmailClass = this.validateEmailClass.bind(this);
        this.validateEmailField = this.validateEmailField.bind(this);
        this.onChangeAddress = this.onChangeAddress.bind(this);
        this.handleLogout = this.handleLogout.bind(this);
        this.onChangeCheckBox = this.onChangeCheckBox.bind(this);
        this.onChangeDateString = this.onChangeDateString.bind(this);
        this.checkTransferState = this.checkTransferState.bind(this);
        this.onChangeUnemployedCheck = this.onChangeUnemployedCheck.bind(this); /*
        this.checkOutstandingAccruals = this.checkOutstandingAccruals.bind(this);
        this.listOutstandingAccruals = this.listOutstandingAccruals.bind(this);*/
        this.loadRegions = this.loadRegions.bind(this);
        this.loadPharmacies = this.loadPharmacies.bind(this);
        this.handleApproveBaskan = this.handleApproveBaskan.bind(this);
        this.handleApproveSekreter = this.handleApproveSekreter.bind(this);
        this.RightExists = this.RightExists.bind(this);
    }


    componentDidMount() {
        if (this.state.mode === "review") {
            this.setState({
                deleteBtnDisabled: true,
                fileAddDisabled: true
            });
        }

        const odaCityId = this.props.currentUser.realm;
        const defaultCityId = 63;

        const odaCity = this.props.cities.find(c => c.id === odaCityId);
        const odaCityOption = odaCity
            ? [{ label: odaCity.ad, value: odaCity.id }]
            : [];

        const loadPromises = [this.loadRegions()];

        if (this.props.selectedMember && this.props.selectedMember.regionSelection) {
            loadPromises.push(this.loadPharmacies(this.props.selectedMember.regionSelection));
        }

        Promise.all(loadPromises).then(() => {

            if (this.props.selectedMember) {
                let selectedMember = deepCopyObject(this.props.selectedMember);

                selectedMember = this.normalizeAddressList(selectedMember);

                const permanentAddress = selectedMember.addressList[0];
                const workAddress = selectedMember.addressList[1];

                const permanentAdrsCitySubdivisions = permanentAddress.cityId
                    ? getCitySubdivisions(permanentAddress.cityId, this.props.citySubdivisions)
                    : getCitySubdivisions(defaultCityId, this.props.citySubdivisions);

                const workAdrsCitySubdivisions = workAddress.cityId
                    ? getCitySubdivisions(workAddress.cityId, this.props.citySubdivisions)
                    : getCitySubdivisions(defaultCityId, this.props.citySubdivisions);

                const permanentAdrsCities = filterCities(this.props.cities, 1000);
                const workAdrsCities =
                    this.props.currentUser.realm === 0
                        ? filterCities(this.props.cities, 1000)
                        : filterCities(this.props.cities, this.props.currentUser.realm);

                const isPreviouslyInactivated = !selectedMember.uyelikAktif;

                selectedMember.belgeTuru =
                    selectedMember.belgeTuru || "DIPLOMA";

                selectedMember.odaKayitTarihi =
                    selectedMember.odaKayitTarihi
                        ? moment.utc(selectedMember.odaKayitTarihi, "YYYY-MM-DD")
                        : null;

                this.setState({
                    memberInfo: {
                        ...selectedMember,
                        city: {
                            ...selectedMember.city,
                            id: odaCityId,
                            ad: odaCity ? odaCity.ad : null
                        }
                    },
                    citySelectionDisabled: true,
                    permanentAdrsCities,
                    workAdrsCities: odaCityOption,
                    permanentAdrsCitySubdivisions,
                    workAdrsCitySubdivisions,
                    isPreviouslyInactivated
                }, () => {
                    if (selectedMember.pharmacySelection) {
                        this.fillWorkPlaceFromPharmacy(selectedMember.pharmacySelection);
                    }
                });

                if (selectedMember.isTransferred === true) {
                    this.setState({ fieldsDisabled: true });
                }

                this.getUserInfo().then(userInfo => {
                    this.setState(prev => ({
                        memberInfo: {
                            ...prev.memberInfo,
                            username: userInfo.username
                        }
                    }));
                });

            } else {
                const permanentAdrsCitySubdivisions =
                    getCitySubdivisions(defaultCityId, this.props.citySubdivisions);

                const workAdrsCitySubdivisions =
                    getCitySubdivisions(defaultCityId, this.props.citySubdivisions);

                const permanentAdrsCities = filterCities(this.props.cities, 1000);

                const workAdrsCities =
                    this.props.currentUser.realm === 0
                        ? filterCities(this.props.cities, 1000)
                        : filterCities(this.props.cities, this.props.currentUser.realm);

                this.setState({
                    permanentAdrsCities,
                    workAdrsCities,
                    permanentAdrsCitySubdivisions,
                    workAdrsCitySubdivisions
                });
            }
        });
    }

    RightExists(searchItem) {
        let exists = false;
        const authorities = this.props.authorities || [];
        for (const authority of authorities) {
            if (authority.authority.includes(searchItem)) {
                exists = true;
            }
        }
        return exists;
    }

    handleApproveSekreter() {
        const member = deepCopyObject(this.state.memberInfo);
        console.log("Member:", member);
        if (!member || !member.id) {
            console.error("Member is undefined or does not have an id");
            return;
        }
        console.log("Member ID: ", member.id);

        const url = `${API_BASE_URL}/uye/update-basvuru-durumu-sekreter/${member.id}`;
        console.log("API URL: ", url);

        request({
            url: url,
            method: "PUT",
        })
            .then((response) => {
                console.log("Response: ", response);
                this.setState({
                    member: response.data,
                });
                Alert.success(
                    "Başvuru Oda Yetkilisi Onayına Başarıyla Gönderilmiştir.",
                    {
                        position: "top-right",
                        effect: "stackslide",
                        timeout: 5000,
                    }
                );
            })
            .catch((error) => {
                console.error("Error: ", error);
                this.setState({ isLoading: false });
                showAxiosError(error);
            });
        this.cancelProcess();
    }

    handleApproveBaskan() {
        const member = deepCopyObject(this.state.memberInfo);
        console.log("Member:", member);
        if (!member || !member.id) {
            console.error("Member is undefined or does not have an id");
            return;
        }
        console.log("Member ID: ", member.id);

        const url = `${API_BASE_URL}/uye/update-basvuru-durumu-baskan-onay/${member.id}`;
        console.log("API URL: ", url);

        request({
            url: url,
            method: "PUT",
        })
            .then((response) => {
                console.log("Response: ", response);
                this.setState({
                    member: response.data,
                });
                Alert.success(
                    "Başvuru Onaylanmıştır.",
                    {
                        position: "top-right",
                        effect: "stackslide",
                        timeout: 5000,
                    }
                );
            })
            .catch((error) => {
                console.error("Error: ", error);
                this.setState({ isLoading: false });
                showAxiosError(error);
            });
        this.cancelProcess();
    }

    handleReject() {
        const member = deepCopyObject(this.state.memberInfo);
        console.log("Member:", member);
        if (!member || !member.id) {
            console.error("Member is undefined or does not have an id");
            return;
        }
        console.log("Member ID: ", member.id);

        const url = `${API_BASE_URL}/uye/update-basvuru-durumu-baskan-red/${member.id}`;
        console.log("API URL: ", url);

        request({
            url: url,
            method: "PUT",
        })
            .then((response) => {
                console.log("Response: ", response);
                this.setState({
                    member: response.data,
                });
                Alert.success(
                    "Başvuru Reddedilmiştir.",
                    {
                        position: "top-right",
                        effect: "stackslide",
                        timeout: 5000,
                    }
                );
            })
            .catch((error) => {
                console.error("Error: ", error);
                this.setState({ isLoading: false });
                showAxiosError(error);
            });
        this.cancelProcess();
    }

    loadRegions() {
        return getRegions()
            .then((response) => {
                const regionOptions = response.data
                    .filter((region) => region && region.regionName)
                    .map((region) => ({
                        label: region.regionName,
                        value: region.id,
                    }));
                regionOptions.sort((a, b) => a.label.localeCompare(b.label));
                this.setState({ regionOptions });
                return regionOptions;
            })
            .catch((error) => {
                showAxiosError(error);
            });
    }

    loadPharmacies(regionId) {
        return getEczanelerByRegion(regionId)
            .then((response) => {
                const pharmacyOptions = response.data.map((pharmacy) => ({
                    label: pharmacy.name,
                    value: pharmacy.id,
                }));
                pharmacyOptions.sort((a, b) => a.label.localeCompare(b.label));
                this.setState({ pharmacyOptions });
                return pharmacyOptions;
            })
            .catch((error) => {
                showAxiosError(error);
            });
    }

    getUserInfo() {
        let params = {
            url: API_BASE_URL + "/user/id/" + this.props.selectedMember.user_id,
            method: "get",
        };

        return request(params)
            .then(function (response) {
                return response.data;
            })
            .catch(function (error) {
                showAxiosError(error);
            });
    }

    checkTransferState() {
        if (
            this.state.memberInfo.transferTo !== undefined &&
            this.state.memberInfo.transferTo !== null
        ) {
            let msg =
                "Üyenin Bekleyen Transfer İşlemi Bulunmaktadır. Üyelik Durumu Değiştirilemez!";
            Alert.error(msg, {
                position: "top-right",
                effect: "stackslide",
                timeout: 10000,
            });
            return true;
        }
        return false;
    }

    onChangeUnemployedCheck(name, value) {
        let memberInfo = _.cloneDeep(this.state.memberInfo);
        let addressList = memberInfo.addressList;
        let permanentAdrsCities = null;
        let permanentAdrsCitySubdivisions = null;
        memberInfo[name] = value;

        if (name === "unemployed") {
            permanentAdrsCities =
                this.props.currentUser.realm === 0
                    ? filterCities(this.props.cities, 1000)
                    : value
                        ? filterCities(this.props.cities, 1000)
                        : filterCities(this.props.cities, this.props.currentUser.realm);
            permanentAdrsCitySubdivisions = null;
            addressList[0]["cityId"] = null;
            addressList[0]["citySubDivisionId"] = null;

            if (value) {
                //üye işsize alınırsa tüm iş yeri bilgilerini boş olarak set  et
                memberInfo["kendiIsyeri"] = false;
                memberInfo["mesulMudur"] = false;
                memberInfo["kamuPersoneli"] = false;
                memberInfo["eczaci"] = false;
                memberInfo["temsilci"] = false;
                memberInfo["unemployed"] = true;
                memberInfo["muesseseSahibi"] = null;
                memberInfo["muesseseAdi"] = null;
                memberInfo["isTel"] = null;
                memberInfo["vergiDairesiAd"] = null;
                memberInfo["vergiNo"] = null;
                memberInfo["ruhsatNo"] = null;
                memberInfo["ruhsatTarihi"] = "";
                addressList[1]["citySubDivisionId"] = null;
                addressList[1]["cityId"] = null;
                addressList[1]["addressString"] = null;
                addressList[1]["semt"] = null;
            }
            console.log(memberInfo, addressList);
        }
        this.setState({
            memberInfo,
            permanentAdrsCities,
            permanentAdrsCitySubdivisions,
        });
    }

    onChangeCheck(name, value) {
        let memberInfo = _.cloneDeep(this.state.memberInfo);

        if (this.checkTransferState()) {
            return;
        }

        let addressList = memberInfo.addressList;
        let permanentAdrsCities = null;
        let permanentAdrsCitySubdivisions = null;

        memberInfo[name] = value;

        if (name === "uyeCalisiyor") {
            permanentAdrsCities =
                this.props.currentUser.realm === 0
                    ? filterCities(this.props.cities, 1000)
                    : value
                        ? filterCities(this.props.cities, 1000)
                        : filterCities(this.props.cities, this.props.currentUser.realm);
            permanentAdrsCitySubdivisions = null;
            addressList[0]["cityId"] = null;
            addressList[0]["citySubDivisionId"] = null;

            if (!value) {
                //çalışma durumu pasife çekilirse tüm iş yeri bilgilerini boş olarak set  et
                memberInfo["kendiIsyeri"] = false;
                memberInfo["mesulMudur"] = false;
                memberInfo["kamuPersoneli"] = false;
                memberInfo["eczaci"] = false;
                memberInfo["temsilci"] = false;
                memberInfo["unemployed"] = true;
                memberInfo["muesseseSahibi"] = null;
                memberInfo["muesseseAdi"] = null;
                memberInfo["isTel"] = null;
                memberInfo["vergiDairesiAd"] = null;
                memberInfo["vergiNo"] = null;
                memberInfo["ruhsatNo"] = null;
                memberInfo["ruhsatTarihi"] = "";
                addressList[1]["citySubDivisionId"] = null;
                addressList[1]["cityId"] = null;
                addressList[1]["addressString"] = null;
                addressList[1]["semt"] = null;
            }
            console.log(memberInfo, addressList);
        }
        this.setState({
            memberInfo,
            permanentAdrsCities,
            permanentAdrsCitySubdivisions,
        });
    }

    validateField(e) {
        let id = e.target.id;
        let rule = e.target.dataset.vdata;
        let boundary = e.target.dataset.vlength;
        let value = e.target.value;
        let result = validateField(rule, boundary, value);
        let error = this.state.error;
        error = Object.assign(error, { [id]: result });
        this.setState({ error });
    }

    normalizeAddressList = (memberInfo) => {
        const list = (memberInfo.addressList || []).filter(Boolean);
        const permanent = list.find(a => a.addressType === "PERMANENT") || {
            id: null,
            addressType: "PERMANENT",
            addressString: null,
            semt: null,
            cityId: null,
            citysubdivisionId: null,
            memberId: memberInfo.id || null,
        };
        const work = list.find(a => a.addressType === "WORK") || {
            id: null,
            addressType: "WORK",
            addressString: null,
            semt: null,
            cityId: null,
            citysubdivisionId: null,
            memberId: memberInfo.id || null,
        };
        if (permanent.citySubDivisionId && !permanent.citysubdivisionId) {
            permanent.citysubdivisionId = permanent.citySubDivisionId;
        }
        if (work.citySubDivisionId && !work.citysubdivisionId) {
            work.citysubdivisionId = work.citySubDivisionId;
        }
        if (permanent.cityId) permanent.cityId = String(permanent.cityId);
        if (permanent.citysubdivisionId) permanent.citysubdivisionId = String(permanent.citysubdivisionId);
        if (work.cityId) work.cityId = String(work.cityId);
        if (work.citysubdivisionId) work.citysubdivisionId = String(work.citysubdivisionId);
        memberInfo.addressList = [permanent, work];
        return memberInfo;
    };

    async validateEmailField(e) {
        let id = e.target.id;
        let rule = e.target.dataset.vdata;
        let boundary = e.target.dataset.vlength;
        let recordId = this.props.selectedMember
            ? this.props.selectedMember.user_id
            : null;
        let value = e.target.value;
        let result = validateField(rule, boundary, value);
        let error = this.state.error;
        let emailAvailabilityError = this.state.emailAvailabilityError;
        error = Object.assign(error, { [id]: result });
        if (recordId !== null) {
            await checkEmailAvailabilityNotIn(value, recordId)
                .then((response) => {
                    if (response.data.available) {
                        error = Object.assign(error, {
                            [id]: { valid: true, message: "" },
                        });
                        emailAvailabilityError = Object.assign(emailAvailabilityError, {
                            [id]: {
                                valid: true,
                                message: "",
                            },
                        });
                        this.setState({ error, emailAvailabilityError });
                    } else {
                        //console.log("false");
                        error = Object.assign(error, {
                            [id]: { valid: false, message: "e-posta kullanımdadır!" },
                        });
                        emailAvailabilityError = Object.assign(emailAvailabilityError, {
                            [id]: {
                                valid: false,
                                message: "e-posta kullanımdadır!",
                            },
                        });
                        this.setState({ error, emailAvailabilityError });
                    }
                })
                .catch(() => {
                    error = Object.assign(error, { [id]: { valid: true, message: "" } });
                    emailAvailabilityError = Object.assign(emailAvailabilityError, {
                        [id]: { valid: true, message: "" },
                    });
                    this.setState({ error, emailAvailabilityError });
                });
        } else {
            await checkEmailAvailability(value)
                .then((response) => {
                    if (response.data.available) {
                        error = Object.assign(error, {
                            [id]: { valid: true, message: "" },
                        });
                        emailAvailabilityError = Object.assign(emailAvailabilityError, {
                            [id]: {
                                valid: true,
                                message: "",
                            },
                        });
                        this.setState({ error, emailAvailabilityError });
                    } else {
                        error = Object.assign(error, {
                            [id]: { valid: false, message: "e-posta kullanımdadır!" },
                        });
                        emailAvailabilityError = Object.assign(emailAvailabilityError, {
                            [id]: {
                                valid: false,
                                message: "e-posta kullanımdadır!",
                            },
                        });
                        this.setState({ error, emailAvailabilityError });
                    }
                })
                .catch(() => {
                    error = Object.assign(error, { [id]: { valid: true, message: "" } });
                    emailAvailabilityError = Object.assign(emailAvailabilityError, {
                        [id]: { valid: true, message: "" },
                    });
                    this.setState({ error, emailAvailabilityError });
                });
        }
    }

    validateClass(id) {
        let error = this.state.error;
        return error[id] === undefined
            ? ""
            : error[id].valid
                ? " has-success"
                : " has-danger";
    }

    validateEmailClass(id) {
        let error = this.state.emailAvailabilityError;
        return error[id] === undefined
            ? ""
            : error[id].valid
                ? " has-success"
                : " has-danger";
    }

    validateMessage(id) {
        if (id === "tGsmTel") {
            const value = this.state.memberInfo.gsmTel || "";
            if (value.length !== 10) {
                return "10 rakam olarak yazılmalı";
            }
        }
        if (id === "tWorkAdresCitySub") {
            const value =
                this.state.memberInfo.addressList[1] &&
                this.state.memberInfo.addressList[1].citySubDivisionId;
            if (!value) {
                return "İlçe seçimi zorunludur";
            }
        }
        let error = this.state.error;
        return error[id] === undefined ? "" : error[id].message;
    }

    validateComponent() {
        let result = validateComponent(this);
        this.setState({
            error: result.error,
        });
        return result;
    }

    onChangeMember(name, value) {
        if (value instanceof moment) {
            value = moment.utc(
                value.format("DD.MM.YYYY").toString() + " 00:00",
                "DD.MM.YYYY HH:mm"
            );
        }
        let memberInfo = this.state.memberInfo;
        memberInfo[name] = value;
        this.setState({ memberInfo });
    }

    onChangeDateString(name, value) {
        if (value === "") {
            value = null;
        }
        if (value !== null) {
            let splitted = value.split(".");
            value = splitted[2] + "-" + splitted[1] + "-" + splitted[0];
        }
        let memberInfo = this.state.memberInfo;
        memberInfo[name] = value;
        this.setState({ memberInfo });
    }

    onChangeMemberUpperCase(name, value) {
        let memberInfo = this.state.memberInfo;

        let upperValue = value
            .replace(/i/g, 'İ')   // Küçük 'i' harfini büyük 'İ' harfine çevir
            .replace(/ı/g, 'I')   // Küçük 'ı' harfini büyük 'I' harfine çevir
            .toUpperCase();       // Diğer tüm karakterleri büyük harfe çevir

        memberInfo[name] = upperValue;
        this.setState({ memberInfo });
    }

    onChangeMemberLowerCase(name, value) {
        let memberInfo = this.state.memberInfo;
        if (name === "username") {
            value = value.toString().replace("@", "");
        }
        memberInfo[name] = value.toString().toLocaleLowerCase();
        this.setState({ memberInfo });
    }

    onChangeCheckBox(name, value) {
        let memberInfo = this.state.memberInfo;
        memberInfo[name] = value;

        if (name === "kendiIsyeri" && value) {
            memberInfo["muesseseSahibi"] =
                memberInfo["ad"] + " " + memberInfo["soyad"];
            memberInfo["calismaBelgeli"] = false;
        } else if (name === "calismaBelgeli" && value) {
            memberInfo["mesulMudur"] = false;
            memberInfo["kendiIsyeri"] = false;
        } else if (name === "mesulMudur" && value) {
            memberInfo["calismaBelgeli"] = false;
        }

        if (memberInfo["calismaBelgeli"] === false) {
            memberInfo["calismaBelgesiPath"] = null;
            memberInfo["calismaBelgesiFile"] = null;
            memberInfo["calismaBelgesiThumbFile"] = null;
        }

        this.setState({ memberInfo });
    }

    onChangeAddress(name, value, index, type) {
        console.log("name,value,index,type", name, value, index, type);
        let addressInfo = this.state.memberInfo.addressList;
        if (type === "string") {
            this.onChangeMemberUpperCase(name, value);
            addressInfo[index][name] = this.state.memberInfo[name];
        } else {
            if (value === null) {
                addressInfo[index][name] = null;
            } else {
                addressInfo[index][name] = value.value;
            }

            if (name === "cityId") {
                if (index === 0) {
                    value !== null
                        ? this.setState({
                            permanentAdrsCitySubdivisions: getCitySubdivisions(
                                value.value,
                                this.props.citySubdivisions
                            ),
                        })
                        : this.setState({ permanentAdrsCitySubdivisions: null });
                } else if (index === 1) {
                    value !== null
                        ? this.setState({
                            workAdrsCitySubdivisions: getCitySubdivisions(
                                value.value,
                                this.props.citySubdivisions
                            ),
                        })
                        : this.setState({ workAdrsCitySubdivisions: null });
                }
                addressInfo[index]["citysubdivisionId"] = null;
            }
        }

        this.setState({ addressInfo });
    }


    onCityInfoChange(name, value) {
        let cityInfo = this.state.memberInfo.city;
        if (value === null) {
            cityInfo[name] = null;
        } else {
            cityInfo[name] = value.value;
        }
        this.setState({ cityInfo });
    }

    onSelectChange(name, value) {
        let memberInfo = { ...this.state.memberInfo };
        memberInfo[name] = value ? value.value : null;

        this.setState({ memberInfo }, async () => {
            if (name === "regionSelection" && value && value.value) {
                this.loadPharmacies(value.value);
            } else if (name === "regionSelection") {
                this.setState({
                    pharmacyOptions: [],
                    memberInfo: {
                        ...this.state.memberInfo,
                        pharmacySelection: null
                    }
                });
                this.clearWorkPlaceFields();
            }


            if (name === "pharmacySelection") {
                if (value && value.value) {
                    await this.fillWorkPlaceFromPharmacy(value.value);
                } else {
                    this.clearWorkPlaceFields();
                }
            }
        });
    }

    fillWorkPlaceFromPharmacy = async (pharmacyId) => {
        const res = await request({
            url: `${API_BASE_URL}/pharmacies/${pharmacyId}/detail`,
            method: "GET",
        });

        const p = res.data;

        const memberInfo = _.cloneDeep(this.state.memberInfo);
        const work = memberInfo.addressList[1];

        memberInfo.muesseseAdi = p.name || null;
        memberInfo.isTel = (p.phone || "").replace(/\D/g, "").slice(-10) || null;
        memberInfo.muesseseSahibi = p.ownerName || null;

        work.addressString = p.location || null;
        work.cityId = p.cityId ? String(p.cityId) : null;
        work.citysubdivisionId = p.citySubDivisionId ? String(p.citySubDivisionId) : null;

        memberInfo.addressList[1] = work;

        const workAdrsCities = filterCities(this.props.cities, 1000);
        const workAdrsCitySubdivisions = p.cityId
            ? getCitySubdivisions(p.cityId, this.props.citySubdivisions)
            : [];

        this.setState({
            memberInfo,
            workAdrsCities,
            workAdrsCitySubdivisions
        });
    };


    clearWorkPlaceFields = () => {
        const memberInfo = _.cloneDeep(this.state.memberInfo);
        const addressList = memberInfo.addressList || [];
        const work = addressList[1] || { addressType: "WORK" };

        memberInfo.kendiIsyeri = false;
        memberInfo.mesulMudur = false;
        memberInfo.kamuPersoneli = false;
        memberInfo.eczaci = false;
        memberInfo.temsilci = false;

        memberInfo.muesseseSahibi = null;
        memberInfo.muesseseAdi = null;
        memberInfo.isTel = null;
        memberInfo.vergiDairesiAd = null;
        memberInfo.vergiNo = null;
        memberInfo.ruhsatNo = null;
        memberInfo.ruhsatTarihi = null;

        work.cityId = null;
        work.citysubdivisionId = null;
        work.addressString = null;
        work.semt = null;

        memberInfo.addressList[1] = work;

        this.setState({
            memberInfo,
            workAdrsCitySubdivisions: null,
        });
    };


    saveMember(action) {
        let self = this;
        let params;
        let data;
        let message;
        let validity = this.validateComponent();
        let emailAvailable = this.state.emailAvailabilityError['tEmail'] === undefined ? true : (this.state.emailAvailabilityError['tEmail'].valid ? true : false);
        let validity_ = this.validateMemberInfo();
        if (validity.valid && validity_ === "") {
            self.setState({ isLoading: true });

            const uyeTipi = this.state.memberInfo.uyeTipi;
            const isPharmacyOwner = (uyeTipi === "ECZANE_SAHIBI" || uyeTipi === "ECZANE_SAHIBI_VE_MESUL_MUDUR");
            if (isPharmacyOwner && this.state.memberInfo.pharmacySelection) {
                const work = this.state.memberInfo.addressList[1];
                this.state.memberInfo.updatePharmacyInfo = true;
                this.state.memberInfo.pharmacyUpdate = {
                    id: this.state.memberInfo.pharmacySelection,
                    name: this.state.memberInfo.muesseseAdi,
                    phone: this.state.memberInfo.isTel,
                    location: work.addressString,
                    cityId: work.cityId ? parseInt(work.cityId) : null,
                    citySubDivisionId: work.citysubdivisionId ? parseInt(work.citysubdivisionId) : null
                };
            }

            let member = deepCopyObject(this.state.memberInfo);

            if (member.newPharmacy) {
                const work = member.addressList[1];
                member.newPharmacy = {
                    ...member.newPharmacy,
                    name: member.muesseseAdi || member.newPharmacy.name,
                    phone: member.isTel || member.newPharmacy.phone,
                    location: work.addressString || member.newPharmacy.location,
                    cityId: work.cityId ? parseInt(work.cityId) : member.newPharmacy.cityId,
                    citySubDivisionId: work.citysubdivisionId ? parseInt(work.citysubdivisionId) : member.newPharmacy.citySubDivisionId
                };
                member.uyeTipi = "ECZANE_SAHIBI";
                member.uyeCalisiyor = true;
                member.kendiIsyeri = true;
            }
            member = trimObject(member);
            member.username = member.tcKimlikNo;
            const permAddress = member.addressList && member.addressList[0];
            if (permAddress && permAddress.citysubdivisionId) {
                permAddress.citysubdivisionId = parseInt(permAddress.citysubdivisionId);
            }
            if (permAddress && permAddress.cityId) {
                permAddress.cityId = parseInt(permAddress.cityId);
            }

            const workAddress = member.addressList && member.addressList[1];
            if (workAddress && workAddress.cityId) {
                member.city = { id: parseInt(workAddress.cityId) };
            } else if (this.props.currentUser.realm && this.props.currentUser.realm !== 0) {
                member.city = { id: this.props.currentUser.realm };
            }

            if (workAddress && workAddress.citysubdivisionId) {
                workAddress.citysubdivisionId = parseInt(workAddress.citysubdivisionId);
            }
            if (workAddress && workAddress.cityId) {
                workAddress.cityId = parseInt(workAddress.cityId);
            }

            if (this.props.currentUser.realm) {
                member.realm = this.props.currentUser.realm;
            }
            if (action === "ONAYLA") {
                member.basvuruDurumu = "ONAYLANDI";
            } else if (action === "KAYDET") {
                if (member.id === null)
                    member.basvuruDurumu = "UYELIK_BILGILERININ_KONTROLU_BEKLENIYOR";
                else
                    member.basvuruDurumu = "ONAYLANDI";
            } else if (action === "IADE") {
                member.basvuruDurumu = "UYELIK_BILGILERININ_TAMAMLANMASI_BEKLENIYOR";
            } else if (action === "RED") {
                member.basvuruDurumu = "REDDEDILDI";
            }
            data = member;
            if (member.id === null) {
                member.username = member.tcKimlikNo;
                message = "Uye Bilgileri Başarıyla Kaydedildi.";
                params = {
                    url: API_BASE_URL + "/uye/create-by-admin/",
                    data: data,
                    method: "post",
                };
            } else {
                if (action === "ONAYLA" || action === "RED" || action === "IADE") {
                    message = "Uye Durumu Başarıyla Güncellendi.";
                    params = {
                        url:
                            API_BASE_URL +
                            "/uye/updateStatus/" +
                            member.id +
                            "/" +
                            member.basvuruDurumu,
                        data: data,
                        method: "put",
                    };
                } else {
                    message = "Uye Bilgileri Başarıyla Güncellendi.";
                    params = {
                        url: API_BASE_URL + "/uye/update-by-admin/",
                        data: data,
                        method: "put",
                    };
                }
            }

            request(params)
                .then(() => {
                    Alert.success(message, {
                        position: "top-right",
                        effect: "stackslide",
                        timeout: 5000,
                    });
                    self.setState({ isLoading: false });
                    this.cancelProcess();
                    self.props.handleSearch(self.props.searchQuery, true);
                })
                .catch(function (error) {
                    self.setState({ isLoading: false });
                    showAxiosError(error);
                });
        } else {
            validity_ = "Hatalı Alanlar var! </br>" + validity_;
            Alert.error(validity_, {
                position: "top-right",
                effect: "stackslide",
                timeout: 20000,
            });
        }
    }

    validateMemberInfo() {
        let memberInfo = this.state.memberInfo;
        let errorMessage = "";

        if (memberInfo.ad === null || memberInfo.ad.toString().trim() === "") {
            errorMessage += "Ad Boş Olamaz!</br>";
        }

        if (
            memberInfo.soyad === null ||
            memberInfo.soyad.toString().trim() === ""
        ) {
            errorMessage += "Soyad Boş Olamaz!</br>";
        }

        if (memberInfo.tcKimlikNo === null) {
            errorMessage += "TC Kimlik No Boş Olamaz!</br>";
        }

        if (memberInfo.tcKimlikNo.toString().trim().length !== 11) {
            errorMessage += "TC Kimlik No Alanı 11 Hane Uzunluğunda Olmalıdır!</br>";
        }

        if (memberInfo.kimlikTipi === null) {
            errorMessage += "Kimlik Tipi Seçiniz!</br>";
        }

        if (memberInfo.kimlikTipi === "TCKimlikKarti") {
            if (memberInfo.kimlikSonGecerlilikTarihi === null) {
                errorMessage += "Kimlik Son Geçerlilik Tarihi Seçiniz!</br>";
            }
        } else if (memberInfo.kimlikTipi === "NufusCuzdani") {
            if (
                memberInfo.kayitNo === null ||
                memberInfo.kayitNo.toString().trim() === ""
            ) {
                errorMessage += "Kimlik Kayıt No Giriniz!</br>";
            }
        }

        if (
            memberInfo.anaAdi === null ||
            memberInfo.anaAdi.toString().trim() === ""
        ) {
            errorMessage += "Ana Adı Boş Olamaz!</br>";
        }

        if (
            memberInfo.babaAdi === null ||
            memberInfo.babaAdi.toString().trim() === ""
        ) {
            errorMessage += "Baba Adı Boş Olamaz!</br>";
        }

        if (
            memberInfo.cuzdanKimlikSeriNo === null ||
            memberInfo.cuzdanKimlikSeriNo.toString().trim() === ""
        ) {
            errorMessage += "Nüfus Cüzdanı/TC Kimlik Seri No Boş Olamaz!</br>";
        }

        if (
            memberInfo.dogumYeri === null ||
            memberInfo.dogumYeri.toString().trim() === ""
        ) {
            errorMessage += "Doğum Yeri Boş Olamaz!</br>";
        }

        if (memberInfo.dogumTarihi === null || memberInfo.dogumTarihi === "") {
            errorMessage += "Dogum Tarihi Boş Olamaz!</br>";
        }

        if (memberInfo.medeniHali === null || memberInfo.medeniHali === "") {
            errorMessage += "Medeni Hali Boş Olamaz!</br>";
        }

        if (
            memberInfo.citySubDivisionId === null ||
            memberInfo.citySubDivisionId === ""
        ) {
            errorMessage += "Oda İlçe Boş Olamaz!</br>";
        }

        if (
            memberInfo.gsmTel === null ||
            memberInfo.gsmTel.toString().trim() === ""
        ) {
            errorMessage += "Cep Telefonu Alanı Boş Olamaz!</br>";
        }
        if (memberInfo.cinsiyet === null) {
            errorMessage += "Cinsiyet Seçiniz!</br>";
        }
        if (memberInfo.belgeTuru === null) {
            errorMessage += "Mezuniyet Belge Türü Seçiniz!</br>";
        }

        if (memberInfo.uyeTipi === null) {
            errorMessage += "Üye Tipini Seçiniz!</br>";
        }
        if (memberInfo.uyeEczaneAcilis === null) {
            errorMessage += "Açılış Sebebini Seçiniz!</br>";
        }
        if (!memberInfo.uyelikAktif) {
            if (
                memberInfo.uyelikPasiflikNedeni === null ||
                memberInfo.uyelikPasiflikNedeni.toString().trim() === ""
            )
                errorMessage += "İlişik Kesme Sebebi Giriniz!</br>";
        }

        if (!memberInfo.uyeCalisiyor) {
            if (
                memberInfo.uyelikDurdurmaDilekcePath === null ||
                memberInfo.uyelikDurdurmaDilekcePath.toString() === ""
            )
                errorMessage += "Pasife Alma Dilekçesi Yükleyiniz!</br>";
        }

        return errorMessage;
    }

    cancelProcess() {
        this.props.cancelProcess();
    }

    handleLogout() {
        this.props.handleLogout();
    }

    openAddPharmacyModal = () => {
        this.setState({ isAddPharmacyModalOpen: true });
    };

    closeAddPharmacyModal = () => {
        this.setState({ isAddPharmacyModalOpen: false });
    };

    fillWorkPlaceFromNewPharmacy = (p) => {

        const memberInfo = _.cloneDeep(this.state.memberInfo);
        const work = memberInfo.addressList[1];

        memberInfo.uyeCalisiyor = true;
        memberInfo.eczaci = true;

        memberInfo.muesseseAdi = p.name;
        memberInfo.isTel = p.phone;
        memberInfo.muesseseSahibi =
            memberInfo.ad && memberInfo.soyad
                ? memberInfo.ad + " " + memberInfo.soyad
                : null;

        work.addressString = p.location;
        work.cityId = p.cityId ? p.cityId.toString() : null;
        work.citysubdivisionId = p.citySubDivisionId ? p.citySubDivisionId.toString() : null;
        memberInfo.addressList[1] = work;

        const workAdrsCities = filterCities(this.props.cities, 1000);
        const workAdrsCitySubdivisions = getCitySubdivisions(
            p.cityId,
            this.props.citySubdivisions
        );

        this.setState({
            memberInfo,
            workAdrsCities,
            workAdrsCitySubdivisions,
        });
    };


    canAddPharmacy = () => {
        const m = this.state.memberInfo;
        if (!m) return false;

        if (m.id !== null) {
            return false;
        }

        if (
            m.uyeTipi !== "ECZANE_SAHIBI" &&
            m.uyeTipi !== "ECZANE_SAHIBI_VE_MESUL_MUDUR"
        ) {
            return false;
        }

        if (m.uyeEczaneAcilis !== "YENI_IS_YERİ_ACMAK_ISTIYORUM") {
            return false;
        }

        return true;
    };


    render() {
        const { member, readOnly, currentUser } = this.state;
        const workAdrsCities = this.state.workAdrsCities || [];
        const workAdrsCitySubdivisions = this.state.workAdrsCitySubdivisions || [];

        const workCityValue =
            this.state.memberInfo.addressList[1] &&
                this.state.memberInfo.addressList[1].cityId
                ? workAdrsCities.find(
                    o => o.value === this.state.memberInfo.addressList[1].cityId
                )
                : null;

        const workTownValue =
            this.state.memberInfo.addressList[1] &&
                this.state.memberInfo.addressList[1].citysubdivisionId
                ? workAdrsCitySubdivisions.find(
                    o =>
                        o.value ===
                        this.state.memberInfo.addressList[1].citysubdivisionId
                )
                : null;


        const cinsiyetOptions = [
            { label: "ERKEK", value: "ERKEK" },
            { label: "KADIN", value: "KADIN" },
        ];

        const medeniHalOptions = [
            { label: "BEKAR", value: "BEKAR" },
            { label: "EVLI", value: "EVLI" },
            { label: "DUL", value: "DUL" },
        ];

        const KimlikTipiOptions = [
            { label: "Nüfus Cüzdanı", value: "NufusCuzdani" },
            { label: "TC Kimlik Kartı", value: "TCKimlikKarti" },
        ];

        const BelgeTipiOptions = [
            { label: "Diploma", value: "DIPLOMA" },
            { label: "Geçici Mezuniyet Belgesi", value: "GECICI_MEZUNIYET" },
        ];

        const BasvuruDurumuOptions = [
            {
                label: "Üyelik Bilgilerinin Tamamlanması Bekleniyor",
                value: "UYELIK_BILGILERININ_TAMAMLANMASI_BEKLENIYOR",
            },
            {
                label: "Üyelik Bilgilerinin Kontrolü Bekleniyor",
                value: "UYELIK_BILGILERININ_KONTROLU_BEKLENIYOR",
            },
            {
                label: "Oda Yetkilisi Onayı Bekleniyor",
                value: "ODA_YETKILISI_ONAYI_BEKLENIYOR",
            },
            { label: "Onaylandı", value: "ONAYLANDI" },
            { label: "Reddedildi", value: "REDDEDILDI" },
        ];

        const UyeTipiOptions = [
            {
                label: "Eczane Sahibi ve Mesul Müdür",
                value: "ECZANE_SAHIBI_VE_MESUL_MUDUR",
            },
            { label: "Eczane Sahibi", value: "ECZANE_SAHIBI" },
            { label: "Mesul Müdür", value: "MESUL_MUDUR" },
            { label: "İkinci Eczacı", value: "IKINCI_ECZACI" },
            { label: "Yardımcı Eczacı", value: "YARDIMCI_ECZACI" },
            { label: "Gönüllü Üye", value: "GONULLU_UYE" },
        ];

        const UyeEczaneAcilisOptions = [
            {
                label: "Yeni İş Yeri Açmak İstiyorum",
                value: "YENI_IS_YERİ_ACMAK_ISTIYORUM",
            },
            {
                label: "Mevcut Eczane/Ecza Deposunda Çalışmak İstiyorum",
                value: "MEVCUT_ECZANE_ECZA_DEPOSUNDA_CALISMAK_ISTIYORUM",
            },
            {
                label: "Mevcut Eczane/Ecza Deposunu Devralmak İstiyorum",
                value: "MEVCUT_ECZANE_ECZA_DEPOSUNU_DEVRALMAK_ISTIYORUM",
            },
            { label: "Gönüllü Üyeyim", value: "GONULLU_UYEYIM" },
        ];

        let tDogumTarihi = this.state.memberInfo.dogumTarihi
            ? { value: moment.utc(this.state.memberInfo.dogumTarihi, "YYYY-MM-DD") }
            : {};
        let tKimlikSonGecerlilikTarihi = this.state.memberInfo
            .kimlikSonGecerlilikTarihi
            ? {
                value: moment.utc(
                    this.state.memberInfo.kimlikSonGecerlilikTarihi,
                    "YYYY-MM-DD"
                ),
            }
            : {};
        let tMezuniyetTarihi = this.state.memberInfo.mezuniyetTarihi
            ? {
                value: moment.utc(
                    this.state.memberInfo.mezuniyetTarihi,
                    "YYYY-MM-DD"
                ),
            }
            : {};
        let tRuhsatTarihi = this.state.memberInfo.ruhsatTarihi
            ? { value: moment.utc(this.state.memberInfo.ruhsatTarihi, "YYYY-MM-DD") }
            : {};
        return (
            <div className="memberForm--main-container">
                {this.state.isLoading && (
                    <div className="loader">
                        <LoadingIndicator />
                    </div>
                )}
                <div className="memberForm-container">
                    <Form>
                        <div className="FormRenk col-sm-12">
                            <span className="form-title">Oda/Portal Giriş Bilgileri</span>
                            <div className="row">
                                <Label className="col-sm-3">Oda İl: *</Label>
                                <div
                                    className={
                                        "col-sm-8 form-group" + this.validateClass("tCity")
                                    }
                                >
                                    <input
                                        type="text"
                                        id="tCity"
                                        name="city"
                                        className="form-control"
                                        value={
                                            (() => {
                                                const realmOdaId = this.props.currentUser.realm;
                                                const odaCity = this.props.cities && this.props.cities.find(c => c.oda && c.oda.id === realmOdaId);
                                                return odaCity ? odaCity.ad : "";
                                            })()
                                        }
                                        readOnly
                                    />

                                    {this.validateMessage("tCity") !== "" && (
                                        <UncontrolledTooltip
                                            placement="right"
                                            target="tCity"
                                            delay={0}
                                        >
                                            {this.validateMessage("tCity")}
                                        </UncontrolledTooltip>
                                    )}
                                </div>
                            </div>
                            {this.state.memberInfo.id !== null && (
                                <div className="row">
                                    <label className="col-sm-3">SicilNo: </label>
                                    <div
                                        className={
                                            "col-sm-8 form-group" + this.validateClass("tOdaSicilNo")
                                        }
                                    >
                                        <input
                                            className="form-control"
                                            disabled={true}
                                            type="text"
                                            name="odaSicilNo"
                                            id="tOdaSicilNo"
                                            maxLength="9"
                                            data-vlength="9"
                                            // inputProps={{'vdata': "required", 'vlength': "9"}}
                                            // onBlur={this.validateField}
                                            // ref="tOdaSicilNo"
                                            value={this.state.memberInfo.odaSicilNo}
                                        //onChange={(e) => this.onChangeMember("odaSicilNo", e.target.value)}
                                        />
                                        {this.validateMessage("tOdaSicilNo") !== "" && (
                                            <UncontrolledTooltip
                                                placement="right"
                                                target="tOdaSicilNo"
                                                delay={0}
                                            >
                                                {this.validateMessage("tOdaSicilNo")}
                                            </UncontrolledTooltip>
                                        )}
                                    </div>
                                </div>
                            )}


                            <div className="row">
                                <Label className="col-sm-3">Kullanıcı Adı: *</Label>
                                <div
                                    className={
                                        "col-sm-8 form-group" + this.validateClass("tUsername")
                                    }
                                >
                                    <input
                                        className="form-control uppercase"
                                        disabled={true}
                                        type="text"
                                        name="username"
                                        id="tUsername"
                                        maxLength="50"
                                        value={this.state.memberInfo.tcKimlikNo || ""}
                                        readOnly
                                    />
                                    {this.validateMessage("tUsername") !== "" && (
                                        <UncontrolledTooltip
                                            placement="right"
                                            target="tUsername"
                                            delay={0}
                                        >
                                            {this.validateMessage("tUsername")}
                                        </UncontrolledTooltip>
                                    )}
                                </div>
                            </div>

                            {
                                <div className="row">
                                    <label className="col-sm-3">E-posta *</label>
                                    <div
                                        className={
                                            "col-sm-8 form-group" + this.validateClass("tEmail")
                                        }
                                    >
                                        <MaskedInput
                                            className="form-control"
                                            disabled={this.state.fieldsDisabled}
                                            type="text"
                                            mask={emailMask}
                                            name="email"
                                            inputProps={{ vdata: "email", vlength: "1,255" }}
                                            id="tEmail"
                                            onBlur={() =>
                                                this.validateField({
                                                    target: {
                                                        id: "tEmail",
                                                        dataset: { vdata: "email", vlength: "1,255" },
                                                        value: this.state.memberInfo.email,
                                                    },
                                                })
                                            }
                                            placeholder="_________@______.___"
                                            ref="tEmail"
                                            value={this.state.memberInfo.email}
                                            onChange={(e) =>
                                                this.onChangeMemberLowerCase("email", e.target.value)
                                            }
                                        />
                                        {this.validateMessage("tEmail") !== "" && (
                                            <UncontrolledTooltip
                                                placement="right"
                                                target="tEmail"
                                                delay={0}
                                            >
                                                {this.validateMessage("tEmail")}
                                            </UncontrolledTooltip>
                                        )}
                                    </div>
                                </div>
                            }
                            <div className="row">
                                <Label className="col-sm-3">Mezuniyet Belge Tipi:*</Label>
                                <div
                                    className={
                                        "col-sm-8 form-group" + this.validateClass("tBelgeTuru")
                                    }
                                >
                                    <Select
                                        className="basic-single"
                                        disabled={this.state.fieldsDisabled}
                                        defaultValue={{ label: "DİPLOMA", value: "DIPLOMA" }}
                                        classNamePrefix="select"
                                        placeholder="Seçiniz"
                                        isClearable={false}
                                        isSearchable={false}
                                        name="belgeTuru"
                                        id="tBelgeTuru"
                                        ref="tBelgeTuru"
                                        style={{ flex: 1 }}
                                        inputProps={{ vdata: "required" }}
                                        options={BelgeTipiOptions}
                                        onChange={(value) =>
                                            this.onSelectChange("belgeTuru", value)
                                        }
                                        value={this.state.memberInfo.belgeTuru}
                                    />
                                    {this.validateMessage("tBelgeTuru") !== "" && (
                                        <UncontrolledTooltip
                                            placement="right"
                                            target="tBelgeTuru"
                                            delay={0}
                                        >
                                            {this.validateMessage("tBelgeTuru")}
                                        </UncontrolledTooltip>
                                    )}
                                </div>
                            </div>

                            {this.state.memberInfo.belgeTuru === "DIPLOMA" && (
                                <div>
                                    <div className="row">
                                        <Label className="col-sm-3">Üniversite:</Label>
                                        <div
                                            className={
                                                "col-sm-8 form-group" +
                                                this.validateClass("tUniversite")
                                            }
                                        >
                                            <input
                                                className="form-control"
                                                type="text"
                                                disabled={this.state.fieldsDisabled}
                                                name="universite"
                                                id="tUniversite"
                                                maxLength="50"
                                                value={this.state.memberInfo.universite || ""}
                                                onChange={(e) =>
                                                    this.onChangeMemberUpperCase(
                                                        "universite",
                                                        e.target.value
                                                    )
                                                }
                                            />
                                            {this.validateMessage("tUniversite") !== "" && (
                                                <UncontrolledTooltip
                                                    placement="right"
                                                    target="tUniversite"
                                                    delay={0}
                                                >
                                                    {this.validateMessage("tUniversite")}
                                                </UncontrolledTooltip>
                                            )}
                                        </div>
                                    </div>
                                    <div className="row">
                                        <Label className="col-sm-3">
                                            Diploma No/Mezuniyet Tarihi:
                                        </Label>
                                        <div
                                            className={
                                                "col-sm-4 form-group" + this.validateClass("tDiplomaNo")
                                            }
                                        >
                                            <input
                                                className="form-control"
                                                type="text"
                                                disabled={this.state.fieldsDisabled}
                                                name="diplomaNo"
                                                id="tDiplomaNo"
                                                maxLength="50"
                                                style={{ flex: 1 }}
                                                value={this.state.memberInfo.diplomaNo || ""}
                                                onChange={(e) =>
                                                    this.onChangeMemberUpperCase(
                                                        "diplomaNo",
                                                        e.target.value
                                                    )
                                                }
                                            />
                                            {this.validateMessage("tDiplomaNo") !== "" && (
                                                <UncontrolledTooltip
                                                    placement="right"
                                                    target="tDiplomaNo"
                                                    delay={0}
                                                >
                                                    {this.validateMessage("tDiplomaNo")}
                                                </UncontrolledTooltip>
                                            )}
                                        </div>
                                        <div
                                            className={
                                                "col-sm-4 form-group" +
                                                this.validateClass("tMezuniyetTarihi")
                                            }
                                        >
                                            <DatePicker
                                                {...tMezuniyetTarihi}
                                                className="basic-single"
                                                placeholder="Tarih seçiniz."
                                                disabled={this.state.fieldsDisabled}
                                                classNamePrefix="select"
                                                format="DD.MM.YYYY"
                                                isClearable={true}
                                                isSearchable={true}
                                                style={{ flex: 1 }}
                                                name="mezuniyetTarihi"
                                                onChange={(date, dateString) =>
                                                    this.onChangeDateString("mezuniyetTarihi", dateString)
                                                }
                                            />
                                            {this.validateMessage("tMezuniyetTarihi") !== "" && (
                                                <UncontrolledTooltip
                                                    placement="right"
                                                    target="tMezuniyetTarihi"
                                                    delay={0}
                                                >
                                                    {this.validateMessage("tMezuniyetTarihi")}
                                                </UncontrolledTooltip>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            )}

                            {this.state.memberInfo.belgeTuru === "GECICI_MEZUNIYET" && (
                                <div className="row">
                                    <Label className="col-sm-3">Mezun Olacağınız Tarih:</Label>
                                    <div
                                        className={
                                            "col-sm-8 form-group" +
                                            this.validateClass("tMezuniyetTarihi")
                                        }
                                    >
                                        <DatePicker
                                            {...tMezuniyetTarihi}
                                            className="basic-single"
                                            placeholder="Tarih seçiniz."
                                            disabled={this.state.fieldsDisabled}
                                            classNamePrefix="select"
                                            format="DD.MM.YYYY"
                                            isClearable={true}
                                            isSearchable={true}
                                            style={{ flex: 1 }}
                                            name="mezuniyetTarihi"
                                            onChange={(date, dateString) =>
                                                this.onChangeDateString("mezuniyetTarihi", dateString)
                                            }
                                        />
                                        {this.validateMessage("tMezuniyetTarihi") !== "" && (
                                            <UncontrolledTooltip
                                                placement="right"
                                                target="tMezuniyetTarihi"
                                                delay={0}
                                            >
                                                {this.validateMessage("tMezuniyetTarihi")}
                                            </UncontrolledTooltip>
                                        )}
                                    </div>
                                </div>
                            )}
                        </div>

                        <div className="FormRenk col-sm-12">
                            <span className="form-title">Üye Durumu</span>
                            <div>
                                {this.props.currentUser.realm === 0 &&
                                    this.state.memberInfo.id !== null && (
                                        <div className="row">
                                            <Label className="col-sm-3">
                                                Üyeliği Dondurulsun Mu?
                                            </Label>
                                            <div
                                                className={
                                                    "col-sm-8 form-group" +
                                                    this.validateClass("tUyeCalisiyor")
                                                }
                                            >
                                                <Switch
                                                    checked={this.state.memberInfo.uyeCalisiyor}
                                                    disabled={this.state.fieldsDisabled}
                                                    checkedChildren="Hayır"
                                                    unCheckedChildren="Evet"
                                                    style={{ width: 150 }}
                                                    onChange={(e) =>
                                                        this.onChangeCheck("uyeCalisiyor", e)
                                                    }
                                                />
                                            </div>
                                        </div>
                                    )}

                                <div>
                                    {this.props.currentUser.realm === 0 &&
                                        this.state.memberInfo.id !== null && (
                                            <div className="row">
                                                <Label className="col-sm-3">Başvuru Durumu : *</Label>


                                                <div className={"col-sm-8 form-group" +
                                                    this.validateClass("tBasvuruDurumu")
                                                }
                                                >
                                                    <Select
                                                        className="basic-single"
                                                        disabled={this.state.fieldsDisabled}
                                                        classNamePrefix="select"
                                                        placeholder="Seçiniz"
                                                        isClearable={false}
                                                        isSearchable={false}
                                                        name="basvuruDurumu"
                                                        id="tBasvuruDurumu"
                                                        ref="tBasvuruDurumu"
                                                        style={{ width: 160, minWidth: 160 }}
                                                        inputProps={{ vdata: "required" }}
                                                        options={BasvuruDurumuOptions}
                                                        onChange={(value) =>
                                                            this.onSelectChange("basvuruDurumu", value)
                                                        }
                                                        value={BasvuruDurumuOptions.find(
                                                            (option) =>
                                                                option.value === this.state.memberInfo.basvuruDurumu
                                                        )}
                                                    />

                                                    {this.validateMessage("tBasvuruDurumu") !== "" && (
                                                        <UncontrolledTooltip
                                                            placement="right"
                                                            target="tBasvuruDurumu"
                                                            delay={0}
                                                        >
                                                            {this.validateMessage("tBasvuruDurumu")}
                                                        </UncontrolledTooltip>
                                                    )}
                                                </div>
                                            </div>

                                        )}

                                </div>


                                <div className="row">
                                    <Label className="col-sm-3">Üye Tipi : *</Label>
                                    <div
                                        className={
                                            "col-sm-8 form-group" + this.validateClass("tUyeTipi")
                                        }
                                    >
                                        <Select
                                            className="basic-single"
                                            disabled={this.state.fieldsDisabled}
                                            classNamePrefix="select"
                                            placeholder="Seçiniz"
                                            isClearable={false}
                                            isSearchable={false}
                                            name="uyeTipi"
                                            id="tUyeTipi"
                                            ref="tUyeTipi"
                                            style={{ width: 160, minWidth: 160 }}
                                            inputProps={{ vdata: "required" }}
                                            options={UyeTipiOptions}
                                            onChange={(value) =>
                                                this.onSelectChange("uyeTipi", value)
                                            }
                                            value={this.state.memberInfo.uyeTipi}
                                        />
                                        {this.validateMessage("tUyeTipi") !== "" && (
                                            <UncontrolledTooltip
                                                placement="right"
                                                target="tUyeTipi"
                                                delay={0}
                                            >
                                                {this.validateMessage("tUyeTipi")}
                                            </UncontrolledTooltip>
                                        )}
                                    </div>
                                </div>

                                <div className="row">
                                    <Label className="col-sm-3">Üye Olma Sebebi:*</Label>
                                    <div
                                        className={
                                            "col-sm-8 form-group" +
                                            this.validateClass("tUyeEczaneAcilis")
                                        }
                                    >
                                        <Select
                                            className="basic-single"
                                            disabled={this.state.fieldsDisabled}
                                            classNamePrefix="select"
                                            placeholder="Seçiniz"
                                            isClearable={false}
                                            isSearchable={false}
                                            name="uyeEczaneAcilis"
                                            id="tUyeEczaneAcilis"
                                            ref="tUyeEczaneAcilis"
                                            style={{ width: 160, minWidth: 160 }}
                                            inputProps={{ vdata: "required" }}
                                            options={UyeEczaneAcilisOptions}
                                            onChange={(value) =>
                                                this.onSelectChange("uyeEczaneAcilis", value)
                                            }
                                            value={this.state.memberInfo.uyeEczaneAcilis}
                                        />
                                        {this.validateMessage("tUyeEczaneAcilis") !== "" && (
                                            <UncontrolledTooltip
                                                placement="right"
                                                target="tUyeEczaneAcilis"
                                                delay={0}
                                            >
                                                {this.validateMessage("tUyeEczaneAcilis")}
                                            </UncontrolledTooltip>
                                        )}
                                    </div>
                                </div>
                                {this.canAddPharmacy() && (
                                    <div>
                                        <div className="row">
                                            <Label className="col-sm-3">Eczane Ekle:</Label>
                                            <div className="col-sm-8">
                                                <Button type="primary"
                                                    onClick={this.openAddPharmacyModal}
                                                >
                                                    Eczane Ekle
                                                </Button>
                                            </div>
                                        </div>

                                        <MemberPharmacyModal
                                            visible={this.state.isAddPharmacyModalOpen}
                                            onClose={this.closeAddPharmacyModal}
                                            cities={this.props.cities}
                                            onSave={(pharmacy) => {
                                                this.setState(prev => ({
                                                    memberInfo: {
                                                        ...prev.memberInfo,
                                                        newPharmacy: pharmacy,
                                                        pharmacySelection: null
                                                    },
                                                    isAddPharmacyModalOpen: false
                                                }), () => {
                                                    this.fillWorkPlaceFromNewPharmacy(pharmacy);
                                                });

                                            }}
                                        />
                                    </div>
                                )}

                                {(this.state.memberInfo.uyeEczaneAcilis ===
                                    "MEVCUT_ECZANE_ECZA_DEPOSUNDA_CALISMAK_ISTIYORUM" ||
                                    this.state.memberInfo.uyeEczaneAcilis ===
                                    "MEVCUT_ECZANE_ECZA_DEPOSUNU_DEVRALMAK_ISTIYORUM") && (
                                        <div>
                                            <div className="row">
                                                <Label className="col-sm-3">Bölge Seçimi:*</Label>
                                                <div
                                                    className={
                                                        "col-sm-8 form-group" +
                                                        this.validateClass("tTownSelection")
                                                    }
                                                >
                                                    <Select
                                                        className="basic-single"
                                                        disabled={this.state.fieldsDisabled}
                                                        classNamePrefix="select"
                                                        placeholder="Bölge seçiniz"
                                                        isClearable={false}
                                                        isSearchable={true}
                                                        name="regionSelection"
                                                        id="regionSelection"
                                                        ref="regionSelection"
                                                        style={{ width: 160, minWidth: 160 }}
                                                        inputProps={{ vdata: "required" }}
                                                        options={this.state.regionOptions}
                                                        onChange={(value) =>
                                                            this.onSelectChange("regionSelection", value)
                                                        }
                                                        value={
                                                            this.state.regionOptions &&
                                                            this.state.regionOptions.find(
                                                                o => o.value === this.state.memberInfo.regionSelection
                                                            )
                                                        }
                                                    />
                                                    {this.validateMessage("regionSelection") !== "" && (
                                                        <UncontrolledTooltip
                                                            placement="right"
                                                            target="regionSelection"
                                                            delay={0}
                                                        >
                                                            {this.validateMessage("regionSelection")}
                                                        </UncontrolledTooltip>
                                                    )}
                                                </div>
                                            </div>

                                            <div className="row">
                                                <Label className="col-sm-3">Eczane Seçimi:*</Label>
                                                <div
                                                    className={
                                                        "col-sm-8 form-group" +
                                                        this.validateClass("tPharmacySelection")
                                                    }
                                                >
                                                    <Select
                                                        className="basic-single"
                                                        disabled={this.state.fieldsDisabled}
                                                        classNamePrefix="select"
                                                        placeholder="Eczane seçiniz"
                                                        isClearable={false}
                                                        isSearchable={true}
                                                        name="pharmacySelection"
                                                        id="tPharmacySelection"
                                                        ref="tPharmacySelection"
                                                        style={{ width: 160, minWidth: 160 }}
                                                        inputProps={{ vdata: "required" }}
                                                        options={this.state.pharmacyOptions}
                                                        onChange={(value) =>
                                                            this.onSelectChange("pharmacySelection", value)
                                                        }
                                                        value={
                                                            this.state.pharmacyOptions &&
                                                            this.state.pharmacyOptions.find(
                                                                o => o.value === this.state.memberInfo.pharmacySelection
                                                            )
                                                        }
                                                    />
                                                    {this.validateMessage("tPharmacySelection") !== "" && (
                                                        <UncontrolledTooltip
                                                            placement="right"
                                                            target="tPharmacySelection"
                                                            delay={0}
                                                        >
                                                            {this.validateMessage("tPharmacySelection")}
                                                        </UncontrolledTooltip>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                <div className="row">
                                    <Label className="col-sm-3">Kamu Personeli mi?:</Label>
                                    <div
                                        className={
                                            "col-sm-8 form-group" +
                                            this.validateClass("tKamuPersoneli")
                                        }
                                    >
                                        <input
                                            name="chkKamuPersoneli"
                                            disabled={
                                                this.state.fieldsDisabled ||
                                                !this.state.memberInfo.uyeCalisiyor
                                            }
                                            type="checkbox"
                                            checked={this.state.memberInfo.kamuPersoneli}
                                            onChange={(e) =>
                                                this.onChangeCheckBox("kamuPersoneli", e.target.checked)
                                            }
                                        />
                                    </div>
                                </div>
                                {this.state.memberInfo.id !== null && (
                                    <div className="row">
                                        <Label className="col-sm-3">
                                            Oda ile İlişiği Kesilsin Mi?
                                        </Label>
                                        <div
                                            className={
                                                "col-sm-8 form-group" +
                                                this.validateClass("tUyelikAktif")
                                            }
                                        >
                                            <Switch
                                                checked={this.state.memberInfo.uyelikAktif}
                                                disabled={
                                                    this.state.isPreviouslyInactivated ||
                                                    this.state.fieldsDisabled
                                                }
                                                checkedChildren="Aktif(Devam Ediyor)"
                                                unCheckedChildren="Pasif(İlişik Kesildi)"
                                                style={{ width: 150 }}
                                                onChange={(e) => {
                                                    this.state.memberInfo.uyelikAktif
                                                        ? this.setState({ inActivateMemberModal: true })
                                                        : this.onChangeCheck("uyelikAktif", e);
                                                }}
                                            />
                                        </div>
                                    </div>
                                )}
                                {this.state.memberInfo.id !== null && (
                                    <div className="row">
                                        <Label className="col-sm-3">Taahhütlü mü ?:</Label>
                                        <div
                                            className={
                                                "col-sm-8 form-group" + this.validateClass("tTaahhut")
                                            }
                                        >
                                            <Switch
                                                checked={this.state.memberInfo.taahhut}
                                                disabled={this.state.fieldsDisabled}
                                                checkedChildren="Evet"
                                                unCheckedChildren="Hayır"
                                                style={{ width: 150 }}
                                                onChange={(e) => this.onChangeCheck("taahhut", e)}
                                            />
                                        </div>
                                    </div>
                                )}
                                <div className="row">
                                    <Label className="col-sm-3">İşsiz mi?:</Label>
                                    <div
                                        className={
                                            "col-sm-8 form-group" + this.validateClass("tUnemployed")
                                        }
                                    >
                                        <Switch
                                            checked={this.state.memberInfo.unemployed}
                                            disabled={this.state.fieldsDisabled}
                                            checkedChildren="Evet"
                                            unCheckedChildren="Hayır"
                                            style={{ width: 150 }}
                                            onChange={(e) =>
                                                this.onChangeUnemployedCheck("unemployed", e)
                                            }
                                        />
                                    </div>
                                </div>
                                {!this.state.memberInfo.uyelikAktif && (
                                    <div className="row">
                                        <Label className="col-sm-3">İlişik Kesme Nedeni: *</Label>
                                        <div
                                            className={
                                                "col-sm-8 form-group" +
                                                this.validateClass("tUyelikPasiflikNedeni")
                                            }
                                        >
                                            <TextArea
                                                className="form-control"
                                                type="text"
                                                name="uyelikPasiflikNedeni"
                                                id="tUyelikPasiflikNedeni"
                                                maxLength="255"
                                                disabled={
                                                    this.state.isPreviouslyInactivated ||
                                                    this.state.fieldsDisabled
                                                }
                                                value={this.state.memberInfo.uyelikPasiflikNedeni}
                                                onChange={(e) =>
                                                    this.onChangeMemberUpperCase(
                                                        "uyelikPasiflikNedeni",
                                                        e.target.value
                                                    )
                                                }
                                            />
                                            {this.validateMessage("tUyelikPasiflikNedeni") !== "" && (
                                                <UncontrolledTooltip
                                                    placement="right"
                                                    target="tUyelikPasiflikNedeni"
                                                    delay={0}
                                                >
                                                    {this.validateMessage("tUyelikPasiflikNedeni")}
                                                </UncontrolledTooltip>
                                            )}
                                        </div>
                                    </div>
                                )}
                                {this.state.memberInfo.taahhut && (
                                    <div className="row">
                                        <Label className="col-sm-3">Taahhüt Belgesi: *</Label>
                                        <div className="col-sm-8 form-group">
                                            <Uploader2
                                                onInfoChange={this.onChangeMember}
                                                fileName="taahhutBelgesiFile"
                                                thumbFileName="taahhutBelgesiThumbFile"
                                                filePathName="taahhutBelgesiPath"
                                                pathPrefix="taahhutbelgesi"
                                                memberTCKN={this.state.memberInfo.tcKimlikNo}
                                                filePath={this.state.memberInfo.taahhutBelgesiPath}
                                                file={this.state.memberInfo.taahhutBelgesiFile}
                                                thumb={this.state.memberInfo.taahhutBelgesiThumbFile}
                                                isDisabled={this.state.fieldsDisabled}
                                            />
                                        </div>
                                    </div>
                                )}
                                {this.props.currentUser.realm === 0 &&
                                    !this.state.memberInfo.uyeCalisiyor && (
                                        <div className="row">
                                            <Label className="col-sm-3">
                                                Pasife Alma Dilekçesi: *
                                            </Label>
                                            <div className="col-sm-8 form-group">
                                                <Uploader2
                                                    onInfoChange={this.onChangeMember}
                                                    fileName="uyelikDurdurmaDilekceFile"
                                                    thumbFileName="uyelikDurdurmaDilekceThumbFile"
                                                    filePathName="uyelikDurdurmaDilekcePath"
                                                    pathPrefix="durdurma"
                                                    memberTCKN={this.state.memberInfo.tcKimlikNo}
                                                    filePath={
                                                        this.state.memberInfo.uyelikDurdurmaDilekcePath
                                                    }
                                                    file={this.state.memberInfo.uyelikDurdurmaDilekceFile}
                                                    thumb={
                                                        this.state.memberInfo.uyelikDurdurmaDilekceThumbFile
                                                    }
                                                    isDisabled={this.state.fieldsDisabled}
                                                />
                                            </div>
                                        </div>
                                    )}
                            </div>
                        </div>
                        <div className="FormRenk col-sm-12">
                            <span className="form-title">Kimlik Bilgileri</span>
                            <div className="row">
                                <Label className="col-sm-3">Adı: *</Label>
                                <div
                                    className={"col-sm-8 form-group" + this.validateClass("tAd")}
                                >
                                    <input
                                        className="form-control"
                                        disabled={this.state.fieldsDisabled}
                                        type="text"
                                        name="ad"
                                        id="tAd"
                                        maxLength="50"
                                        data-vlength="1,50"
                                        onBlur={this.validateField}
                                        ref="tAd"
                                        value={this.state.memberInfo.ad || ""}
                                        onChange={(e) =>
                                            this.onChangeMemberUpperCase("ad", e.target.value)
                                        }
                                    />
                                    {this.validateMessage("tAd") !== "" && (
                                        <UncontrolledTooltip
                                            placement="right"
                                            target="tAd"
                                            delay={0}
                                        >
                                            {this.validateMessage("tAd")}
                                        </UncontrolledTooltip>
                                    )}
                                </div>
                            </div>
                            <div className="row">
                                <Label className="col-sm-3">Soyadı */Eski Soyadı:</Label>
                                <div
                                    className={
                                        "col-sm-4 form-group" + this.validateClass("tSoyad")
                                    }
                                >
                                    <input
                                        className="form-control"
                                        type="text"
                                        disabled={this.state.fieldsDisabled}
                                        name="soyad"
                                        id="tSoyad"
                                        maxLength="50"
                                        data-vlength="1,50"
                                        onBlur={this.validateField}
                                        ref="tSoyad"
                                        value={this.state.memberInfo.soyad || ""}
                                        onChange={(e) =>
                                            this.onChangeMemberUpperCase("soyad", e.target.value)
                                        }
                                    />
                                    {this.validateMessage("tSoyad") !== "" && (
                                        <UncontrolledTooltip
                                            placement="right"
                                            target="tSoyad"
                                            delay={0}
                                        >
                                            {this.validateMessage("tSoyad")}
                                        </UncontrolledTooltip>
                                    )}
                                </div>
                                <div
                                    className={
                                        "col-sm-4 form-group" + this.validateClass("tEskiSoyad")
                                    }
                                >
                                    <input
                                        className="form-control"
                                        type="text"
                                        disabled={this.state.fieldsDisabled}
                                        name="eskiSoyad"
                                        id="tEskiSoyad"
                                        maxLength="50"
                                        data-vlength="1,50"
                                        value={this.state.memberInfo.eskiSoyad || ""}
                                        onChange={(e) =>
                                            this.onChangeMemberUpperCase("eskiSoyad", e.target.value)
                                        }
                                    />
                                    {this.validateMessage("tEskiSoyad") !== "" && (
                                        <UncontrolledTooltip
                                            placement="right"
                                            target="tEskiSoyad"
                                            delay={0}
                                        >
                                            {this.validateMessage("tEskiSoyad")}
                                        </UncontrolledTooltip>
                                    )}
                                </div>
                            </div>
                            <div className="row">
                                <Label className="col-sm-3">TC Kimlik No: *</Label>
                                <div
                                    className={
                                        "col-sm-8 form-group" + this.validateClass("tTckNo")
                                    }
                                >
                                    <input
                                        className="form-control"
                                        type="text"
                                        disabled={this.state.fieldsDisabled}
                                        name="tckNo"
                                        id="tTckNo"
                                        maxLength="11"
                                        //inputProps={{vdata: "identifier", vlength: '11'}}
                                        data-vlength="11"
                                        onBlur={() =>
                                            this.validateField({
                                                target: {
                                                    id: "tTckNo",
                                                    dataset: { vdata: "identifier", vlength: "11" },
                                                    value: this.state.memberInfo.tcKimlikNo,
                                                },
                                            })
                                        }
                                        ref="tTckNo"
                                        value={this.state.memberInfo.tcKimlikNo || ""}
                                        onChange={(e) =>
                                            this.onChangeMember("tcKimlikNo", e.target.value)
                                        }
                                    />
                                    {this.validateMessage("tTckNo") !== "" && (
                                        <UncontrolledTooltip
                                            placement="right"
                                            target="tTckNo"
                                            delay={0}
                                        >
                                            {this.validateMessage("tTckNo")}
                                        </UncontrolledTooltip>
                                    )}
                                </div>
                            </div>

                            <div className="row">
                                <Label className="col-sm-3">Doğum Tarihi: *</Label>
                                <div
                                    className={
                                        "col-sm-8 form-group" + this.validateClass("tDogumTarihi")
                                    }
                                >
                                    <DatePicker
                                        {...tDogumTarihi}
                                        className="basic-single"
                                        placeholder="Tarih seçiniz."
                                        disabled={this.state.fieldsDisabled}
                                        classNamePrefix="select"
                                        format="DD.MM.YYYY"
                                        isClearable={true}
                                        isSearchable={true}
                                        name="dogumTarihi"
                                        id="tDogumTarihi"
                                        ref="tDogumTarihi"
                                        style={{ width: 160 }}
                                        inputProps={{ vdata: "required" }}
                                        onChange={(date, dateString) =>
                                            this.onChangeDateString("dogumTarihi", dateString)
                                        }
                                    />
                                    {this.validateMessage("tDogumTarihi") !== "" && (
                                        <UncontrolledTooltip
                                            placement="right"
                                            target="tDogumTarihi"
                                            delay={0}
                                        >
                                            {this.validateMessage("tDogumTarihi")}
                                        </UncontrolledTooltip>
                                    )}
                                </div>
                            </div>
                            <div className="row">
                                <Label className="col-sm-3">Cinsiyet: *</Label>
                                <div
                                    className={
                                        "col-sm-8 form-group" + this.validateClass("tCinsiyet")
                                    }
                                >
                                    <Select
                                        className="basic-single"
                                        disabled={this.state.fieldsDisabled}
                                        classNamePrefix="select"
                                        placeholder="Seçiniz"
                                        isClearable={false}
                                        isSearchable={false}
                                        name="cinsiyet"
                                        id="tCinsiyet"
                                        ref="tCinsiyet"
                                        style={{ width: 160, minWidth: 160 }}
                                        inputProps={{ vdata: "required" }}
                                        options={cinsiyetOptions}
                                        onChange={(value) => this.onSelectChange("cinsiyet", value)}
                                        value={this.state.memberInfo.cinsiyet}
                                    />
                                    {this.validateMessage("tCinsiyet") !== "" && (
                                        <UncontrolledTooltip
                                            placement="right"
                                            target="tCinsiyet"
                                            delay={0}
                                        >
                                            {this.validateMessage("tCinsiyet")}
                                        </UncontrolledTooltip>
                                    )}
                                </div>
                            </div>

                            <div className="row">
                                <Label className="col-sm-3">Baba Adı: *</Label>
                                <div
                                    className={
                                        "col-sm-8 form-group" + this.validateClass("tBabaAdi")
                                    }
                                >
                                    <input
                                        className="form-control"
                                        type="text"
                                        disabled={this.state.fieldsDisabled}
                                        name="babaAdi"
                                        id="tBabaAdi"
                                        maxLength="50"
                                        data-vlength="1,50"
                                        onBlur={this.validateField}
                                        ref="tBabaAdi"
                                        value={this.state.memberInfo.babaAdi || ""}
                                        onChange={(e) =>
                                            this.onChangeMemberUpperCase("babaAdi", e.target.value)
                                        }
                                    />
                                    {this.validateMessage("tBabaAdi") !== "" && (
                                        <UncontrolledTooltip
                                            placement="right"
                                            target="tBabaAdi"
                                            delay={0}
                                        >
                                            {this.validateMessage("tBabaAdi")}
                                        </UncontrolledTooltip>
                                    )}
                                </div>
                            </div>

                            <div className="row">
                                <Label className="col-sm-3">Ana Adı: *</Label>
                                <div
                                    className={
                                        "col-sm-8 form-group" + this.validateClass("tAnaAdi")
                                    }
                                >
                                    <input
                                        className="form-control"
                                        type="text"
                                        disabled={this.state.fieldsDisabled}
                                        name="anaAdi"
                                        id="tAnaAdi"
                                        maxLength="50"
                                        data-vlength="1,50"
                                        onBlur={this.validateField}
                                        ref="tAnaAdi"
                                        value={this.state.memberInfo.anaAdi || ""}
                                        onChange={(e) =>
                                            this.onChangeMemberUpperCase("anaAdi", e.target.value)
                                        }
                                    />
                                    {this.validateMessage("tAnaAdi") !== "" && (
                                        <UncontrolledTooltip
                                            placement="right"
                                            target="tAnaAdi"
                                            delay={0}
                                        >
                                            {this.validateMessage("tAnaAdi")}
                                        </UncontrolledTooltip>
                                    )}
                                </div>
                            </div>

                            <div className="row">
                                <Label className="col-sm-3">Kimlik Tipi: *</Label>
                                <div
                                    className={
                                        "col-sm-8 form-group" + this.validateClass("tKimlikTipi")
                                    }
                                >
                                    <Select
                                        className="basic-single"
                                        disabled={this.state.fieldsDisabled}
                                        classNamePrefix="select"
                                        placeholder="Seçiniz"
                                        isClearable={false}
                                        isSearchable={false}
                                        name="kimlikTipi"
                                        id="tKimlikTipi"
                                        ref="tKimlikTipi"
                                        style={{ width: 160, minWidth: 160 }}
                                        inputProps={{ vdata: "required" }}
                                        options={KimlikTipiOptions}
                                        onChange={(value) =>
                                            this.onSelectChange("kimlikTipi", value)
                                        }
                                        value={this.state.memberInfo.kimlikTipi}
                                    />
                                    {this.validateMessage("tKimlikTipi") !== "" && (
                                        <UncontrolledTooltip
                                            placement="right"
                                            target="tKimlikTipi"
                                            delay={0}
                                        >
                                            {this.validateMessage("tKimlikTipi")}
                                        </UncontrolledTooltip>
                                    )}
                                </div>
                            </div>

                            <div className="row">
                                <Label className="col-sm-3">
                                    N.Cüzdanı/TC Kimlik Seri No: *
                                </Label>
                                <div
                                    className={
                                        "col-sm-8 form-group" +
                                        this.validateClass("tCuzdanKimlikSeriNo")
                                    }
                                >
                                    <input
                                        className="form-control"
                                        type="text"
                                        disabled={this.state.fieldsDisabled}
                                        name="cuzdanKimlikSeriNo"
                                        id="tCuzdanKimlikSeriNo"
                                        maxLength="50"
                                        data-vlength="1,50"
                                        onBlur={this.validateField}
                                        ref="tCuzdanKimlikSeriNo"
                                        value={this.state.memberInfo.cuzdanKimlikSeriNo || ""}
                                        onChange={(e) =>
                                            this.onChangeMemberUpperCase(
                                                "cuzdanKimlikSeriNo",
                                                e.target.value
                                            )
                                        }
                                    />
                                    {this.validateMessage("tCuzdanKimlikSeriNo") !== "" && (
                                        <UncontrolledTooltip
                                            placement="right"
                                            target="tCuzdanKimlikSeriNo"
                                            delay={0}
                                        >
                                            {this.validateMessage("tCuzdanKimlikSeriNo")}
                                        </UncontrolledTooltip>
                                    )}
                                </div>
                            </div>

                            {this.state.memberInfo.kimlikTipi === "NufusCuzdani" ? (
                                <div className="row">
                                    <Label className="col-sm-3">Kimlik Kayıt No:</Label>
                                    <div
                                        className={
                                            "col-sm-8 form-group" + this.validateClass("tKayitNo")
                                        }
                                    >
                                        <input
                                            className="form-control"
                                            type="text"
                                            disabled={this.state.fieldsDisabled}
                                            name="KayitNo"
                                            id="tKayitNo"
                                            maxLength="50"
                                            data-vlength="1,50"
                                            onBlur={this.validateField}
                                            ref="tKayitNo"
                                            value={this.state.memberInfo.kayitNo || ""}
                                            onChange={(e) =>
                                                this.onChangeMemberUpperCase("kayitNo", e.target.value)
                                            }
                                        />
                                        {this.validateMessage("tKayitNo") !== "" && (
                                            <UncontrolledTooltip
                                                placement="right"
                                                target="tKayitNo"
                                                delay={0}
                                            >
                                                {this.validateMessage("tKayitNo")}
                                            </UncontrolledTooltip>
                                        )}
                                    </div>
                                </div>
                            ) : (
                                ""
                            )}

                            {this.state.memberInfo.kimlikTipi === "TCKimlikKarti" ? (
                                <div className="row">
                                    <Label className="col-sm-3">
                                        Kimlik Son Geçerlilik Tarihi:
                                    </Label>
                                    <div
                                        className={
                                            "col-sm-8 form-group" +
                                            this.validateClass("tKimlikSonGecerlilikTarihi")
                                        }
                                    >
                                        <DatePicker
                                            {...tKimlikSonGecerlilikTarihi}
                                            className="basic-single"
                                            placeholder="Tarih seçiniz."
                                            disabled={this.state.fieldsDisabled}
                                            classNamePrefix="select"
                                            format="DD.MM.YYYY"
                                            isClearable={true}
                                            isSearchable={true}
                                            name="kimlikSonGecerlilikTarihi"
                                            id="tKimlikSonGecerlilikTarihi"
                                            ref="tKimlikSonGecerlilikTarihi"
                                            style={{ width: 160 }}
                                            inputProps={{ vdata: "required" }}
                                            onChange={(date, dateString) =>
                                                this.onChangeDateString(
                                                    "kimlikSonGecerlilikTarihi",
                                                    dateString
                                                )
                                            }
                                        />
                                        {this.validateMessage("tKimlikSonGecerlilikTarihi") !==
                                            "" && (
                                                <UncontrolledTooltip
                                                    placement="right"
                                                    target="tKimlikSonGecerlilikTarihi"
                                                    delay={0}
                                                >
                                                    {this.validateMessage("tKimlikSonGecerlilikTarihi")}
                                                </UncontrolledTooltip>
                                            )}
                                    </div>
                                </div>
                            ) : (
                                ""
                            )}
                            <div className="row">
                                <Label className="col-sm-3">Doğum Yeri: *</Label>
                                <div
                                    className={
                                        "col-sm-8 form-group" + this.validateClass("tDogumYeri")
                                    }
                                >
                                    <input
                                        className="form-control"
                                        type="text"
                                        disabled={this.state.fieldsDisabled}
                                        name="dogumYeri"
                                        id="tDogumYeri"
                                        maxLength="50"
                                        data-vlength="1,50"
                                        onBlur={this.validateField}
                                        ref="tDogumYeri"
                                        value={this.state.memberInfo.dogumYeri || ""}
                                        onChange={(e) =>
                                            this.onChangeMemberUpperCase("dogumYeri", e.target.value)
                                        }
                                    />
                                    {this.validateMessage("tDogumYeri") !== "" && (
                                        <UncontrolledTooltip
                                            placement="right"
                                            target="tDogumYeri"
                                            delay={0}
                                        >
                                            {this.validateMessage("tDogumYeri")}
                                        </UncontrolledTooltip>
                                    )}
                                </div>
                            </div>

                            <div className="row">
                                <Label className="col-sm-3">Medeni Hali: *</Label>
                                <div
                                    className={
                                        "col-sm-8 form-group" + this.validateClass("tMedeniHali")
                                    }
                                >
                                    <Select
                                        className="basic-single"
                                        disabled={this.state.fieldsDisabled}
                                        classNamePrefix="select"
                                        placeholder="Seçiniz"
                                        isClearable={false}
                                        isSearchable={false}
                                        name="medeniHal"
                                        id="tMedeniHali"
                                        ref="tMedeniHali"
                                        style={{ width: 160, minWidth: 160 }}
                                        inputProps={{ vdata: "required" }}
                                        options={medeniHalOptions}
                                        onChange={(value) =>
                                            this.onSelectChange("medeniHali", value)
                                        }
                                        value={this.state.memberInfo.medeniHali}
                                    />
                                    {this.validateMessage("tMedeniHali") !== "" && (
                                        <UncontrolledTooltip
                                            placement="right"
                                            target="tMedeniHali"
                                            delay={0}
                                        >
                                            {this.validateMessage("tMedeniHali")}
                                        </UncontrolledTooltip>
                                    )}
                                </div>
                            </div>
                            <div className="row">
                                <Label className="col-sm-3">Kan Grubu:</Label>
                                <div
                                    className={
                                        "col-sm-8 form-group" + this.validateClass("tKanGrubu")
                                    }
                                >
                                    <input
                                        className="form-control"
                                        type="text"
                                        disabled={this.state.fieldsDisabled}
                                        name="kanGrubu"
                                        id="tKanGrubu"
                                        maxLength="7"
                                        onBlur={this.validateField}
                                        style={{ width: 160, minWidth: 160 }}
                                        value={this.state.memberInfo.kanGrubu || ""}
                                        onChange={(e) =>
                                            this.onChangeMemberUpperCase("kanGrubu", e.target.value)
                                        }
                                    />
                                    {this.validateMessage("tKanGrubu") !== "" && (
                                        <UncontrolledTooltip
                                            placement="right"
                                            target="tKanGrubu"
                                            delay={0}
                                        >
                                            {this.validateMessage("tKanGrubu")}
                                        </UncontrolledTooltip>
                                    )}
                                </div>
                            </div>
                        </div>
                        <div className="FormRenk col-sm-12">
                            <span className="form-title">İletişim Bilgileri</span>
                            <div className="row">
                                <Label className="col-sm-3">Cep Telefonu: *</Label>
                                <div
                                    className={
                                        "col-sm-8 form-group" + this.validateClass("tGsmTel")
                                    }
                                >
                                    <input
                                        className="form-control"
                                        type="text"
                                        disabled={this.state.fieldsDisabled}
                                        placeholder="1234567890"
                                        name="gsmTel"
                                        id="tGsmTel"
                                        maxLength="10"
                                        data-vlength="10"
                                        onBlur={this.validateField}
                                        ref="tGsmTel"
                                        value={this.state.memberInfo.gsmTel || ""}
                                        onChange={(e) =>
                                            this.onChangeMember("gsmTel", e.target.value)
                                        }
                                    />
                                    {this.validateMessage("tGsmTel") !== "" && (
                                        <UncontrolledTooltip
                                            placement="right"
                                            target="tGsmTel"
                                            delay={0}
                                        >
                                            {this.validateMessage("tGsmTel")}
                                        </UncontrolledTooltip>
                                    )}
                                </div>
                            </div>
                            <div className="row">
                                <Label className="col-sm-3">İkamet Adresi: *</Label>
                                <div
                                    className={
                                        "col-sm-8 form-group" + this.validateClass("tPermAdres")
                                    }
                                >
                                    <TextArea
                                        className="form-control"
                                        type="text"
                                        disabled={this.state.fieldsDisabled}
                                        name="permAdres"
                                        style={{ height: 60, minHeight: 60 }}
                                        value={
                                            this.state.memberInfo.addressList[0] &&
                                            this.state.memberInfo.addressList[0].addressString
                                        }


                                        onChange={(e) => {

                                            this.onChangeAddress("addressString", e.target.value, 0, "string");

                                        }}
                                    />

                                    {this.validateMessage("tPermAdres") !== "" && (
                                        <UncontrolledTooltip
                                            placement="right"
                                            target="tPermAdres"
                                            delay={0}
                                        >
                                            {this.validateMessage("tPermAdres")}
                                        </UncontrolledTooltip>
                                    )}
                                </div>
                            </div>


                            <div className="row">
                                <Label className="col-sm-3">İkamet İl/İlçe: </Label>
                                <div
                                    className={
                                        "col-sm-4 form-group" + this.validateClass("tPermAdrsCity")
                                    }
                                >
                                    <Select
                                        className="basic-single"
                                        disabled={this.state.fieldsDisabled}
                                        classNamePrefix="select"
                                        placeholder="İl seçiniz."
                                        isClearable={false}
                                        isSearchable={true}
                                        name="permAdrsCity"
                                        id="tPermAdrsCity"
                                        style={{ flex: 0.9 }}
                                        options={this.state.permanentAdrsCities}
                                        onChange={(value) =>
                                            this.onChangeAddress("cityId", value, 0, "select")
                                        }
                                        value={
                                            this.state.memberInfo.addressList[0] &&
                                            this.state.memberInfo.addressList[0].cityId
                                        }
                                    />

                                    {this.validateMessage("tPermAdrsCity") !== "" && (
                                        <UncontrolledTooltip
                                            placement="right"
                                            target="tPermAdrsCity"
                                            delay={0}
                                        >
                                            {this.validateMessage("tPermAdrsCity")}
                                        </UncontrolledTooltip>
                                    )}
                                </div>
                                <div
                                    className={
                                        "col-sm-4 form-group" +
                                        this.validateClass("tPermAdrsCitySub")
                                    }
                                >
                                    <Select
                                        className="basic-single"
                                        disabled={this.state.fieldsDisabled}
                                        classNamePrefix="select"
                                        placeholder="İlçe seçiniz."
                                        isClearable={false}
                                        isSearchable={true}
                                        name="permAdrsCitySub"
                                        id="tPermAdrsCitySub"
                                        style={{ flex: 0.9 }}
                                        options={this.state.permanentAdrsCitySubdivisions}
                                        onChange={(value) =>
                                            this.onChangeAddress(
                                                "citysubdivisionId",
                                                value,
                                                0,
                                                "select"
                                            )
                                        }
                                        value={
                                            this.state.memberInfo.addressList[0] &&
                                            this.state.memberInfo.addressList[0].citysubdivisionId
                                        }
                                        inputProps={{ vdata: "required" }}
                                    />
                                    {this.validateMessage("tPermAdrsCitySub") !== "" && (
                                        <UncontrolledTooltip
                                            placement="right"
                                            target="tPermAdrsCitySub"
                                            delay={0}
                                        >
                                            {this.validateMessage("tPermAdrsCitySub")}
                                        </UncontrolledTooltip>
                                    )}
                                </div>
                            </div>

                            <div className="row">
                                <Label className="col-sm-3">Semt: </Label>
                                <div
                                    className={
                                        "col-sm-8 form-group" + this.validateClass("tPermSemt")
                                    }
                                >
                                    <input
                                        className="form-control"
                                        type="text"
                                        disabled={this.state.fieldsDisabled}
                                        name="permSemt"
                                        id="tPermSemt"
                                        maxLength="20"
                                        value={
                                            this.state.memberInfo.addressList[0] &&
                                            this.state.memberInfo.addressList[0].semt
                                        }

                                        onChange={(e) => {
                                            this.onChangeMemberUpperCase("semt", e.target.value);
                                            const updatedValue = this.state.memberInfo.semt;
                                            this.onChangeAddress("semt", updatedValue, 0, "string");
                                        }}
                                    />
                                    {this.validateMessage("tPermSemt") !== "" && (
                                        <UncontrolledTooltip
                                            placement="right"
                                            target="tPermSemt"
                                            delay={0}
                                        >
                                            {this.validateMessage("tPermSemt")}
                                        </UncontrolledTooltip>
                                    )}
                                </div>
                            </div>


                            <div className="row">
                                <Label className="col-sm-3">Ev Telefonu:</Label>
                                <div
                                    className={
                                        "col-sm-8 form-group" + this.validateClass("tEvTel")
                                    }
                                >
                                    <input
                                        className="form-control"
                                        type="text"
                                        disabled={this.state.fieldsDisabled}
                                        placeholder="1234567890"
                                        name="evTel"
                                        id="tEvTel"
                                        maxLength="10"
                                        value={this.state.memberInfo.evTel || ""}
                                        onChange={(e) =>
                                            this.onChangeMember("evTel", e.target.value)
                                        }
                                    />
                                    {this.validateMessage("tEvTel") !== "" && (
                                        <UncontrolledTooltip
                                            placement="right"
                                            target="tEvTel"
                                            delay={0}
                                        >
                                            {this.validateMessage("tEvTel")}
                                        </UncontrolledTooltip>
                                    )}
                                </div>
                            </div>
                        </div>
                        <div className="FormRenk col-sm-12">
                            <span className="form-title">İş Yeri Bilgileri</span>
                            <div className="row">
                                <Label className="col-sm-3">Kendi İş Yeri mi?:</Label>
                                <div
                                    className={
                                        "col-sm-8 form-group" + this.validateClass("tKendiIsYeri")
                                    }
                                >
                                    <input
                                        name="chkKendiIsYeri"
                                        disabled={
                                            this.state.fieldsDisabled ||
                                            !this.state.memberInfo.uyeCalisiyor ||
                                            !(this.state.memberInfo.uyeTipi === "ECZANE_SAHIBI" ||
                                                this.state.memberInfo.uyeTipi === "ECZANE_SAHIBI_VE_MESUL_MUDUR")
                                        }
                                        type="checkbox"
                                        checked={this.state.memberInfo.kendiIsyeri}
                                        onChange={(e) =>
                                            this.onChangeCheckBox("kendiIsyeri", e.target.checked)
                                        }
                                    />
                                </div>
                            </div>
                            <div className="row">
                                <Label className="col-sm-3">Mesul Müdür mü?:</Label>
                                <div
                                    className={
                                        "col-sm-8 form-group" + this.validateClass("tmesulMudur")
                                    }
                                >
                                    <input
                                        name="chkMesulMudur"
                                        disabled={
                                            this.state.fieldsDisabled ||
                                            !this.state.memberInfo.uyeCalisiyor
                                        }
                                        type="checkbox"
                                        checked={this.state.memberInfo.mesulMudur}
                                        onChange={(e) =>
                                            this.onChangeCheckBox("mesulMudur", e.target.checked)
                                        }
                                    />
                                </div>
                            </div>
                            <div className="row">
                                <Label className="col-sm-3">
                                    Çalışma Belgeli Personel mi?:
                                </Label>
                                <div
                                    className={
                                        "col-sm-8 form-group" +
                                        this.validateClass("tCalismaBelgeli")
                                    }
                                >
                                    <input
                                        name="chkCalismaBelgeli"
                                        disabled={
                                            this.state.fieldsDisabled ||
                                            !this.state.memberInfo.uyeCalisiyor
                                        }
                                        type="checkbox"
                                        checked={this.state.memberInfo.calismaBelgeli}
                                        onChange={(e) =>
                                            this.onChangeCheckBox("calismaBelgeli", e.target.checked)
                                        }
                                    />
                                </div>
                            </div>
                            <div className="row">
                                <Label className="col-sm-3">Eczacı mı?:</Label>
                                <div
                                    className={
                                        "col-sm-8 form-group" + this.validateClass("tEczaci")
                                    }
                                >
                                    <input
                                        name="chkEczaci"
                                        disabled={
                                            this.state.fieldsDisabled ||
                                            !this.state.memberInfo.uyeCalisiyor ||
                                            !(this.state.memberInfo.uyeTipi === "ECZANE_SAHIBI" ||
                                                this.state.memberInfo.uyeTipi === "ECZANE_SAHIBI_VE_MESUL_MUDUR")
                                        }
                                        type="checkbox"
                                        checked={this.state.memberInfo.eczaci}
                                        onChange={(e) =>
                                            this.onChangeCheckBox("eczaci", e.target.checked)
                                        }
                                    />
                                </div>
                            </div>
                            <div className="row">
                                <Label className="col-sm-3">Temsilci mi?:</Label>
                                <div
                                    className={
                                        "col-sm-8 form-group" + this.validateClass("tTemsilci")
                                    }
                                >
                                    <input
                                        name="chkTemsilci"
                                        disabled={
                                            this.state.fieldsDisabled ||
                                            !this.state.memberInfo.uyeCalisiyor
                                        }
                                        type="checkbox"
                                        checked={this.state.memberInfo.temsilci}
                                        onChange={(e) =>
                                            this.onChangeCheckBox("temsilci", e.target.checked)
                                        }
                                    />
                                </div>
                            </div>
                            <div className="row">
                                <Label className="col-sm-3">Müessese Sahibi:</Label>
                                <div
                                    className={
                                        "col-sm-8 form-group" +
                                        this.validateClass("tMuesseseSahibi")
                                    }
                                >
                                    <input
                                        className="form-control"
                                        type="text"
                                        disabled={
                                            this.state.fieldsDisabled ||
                                            !this.state.memberInfo.uyeCalisiyor ||
                                            !(this.state.memberInfo.uyeTipi === "ECZANE_SAHIBI" ||
                                                this.state.memberInfo.uyeTipi === "ECZANE_SAHIBI_VE_MESUL_MUDUR")
                                        }
                                        name="muesseseSahibi"
                                        id="tMuesseseSahibi"
                                        maxLength="50"
                                        value={this.state.memberInfo.muesseseSahibi || ""}
                                        onChange={(e) =>
                                            this.onChangeMemberUpperCase(
                                                "muesseseSahibi",
                                                e.target.value
                                            )
                                        }
                                    />
                                    {this.validateMessage("tMuesseseSahibi") !== "" && (
                                        <UncontrolledTooltip
                                            placement="right"
                                            target="tMuesseseSahibi"
                                            delay={0}
                                        >
                                            {this.validateMessage("tMuesseseSahibi")}
                                        </UncontrolledTooltip>
                                    )}
                                </div>
                            </div>

                            <div className="row">
                                <Label className="col-sm-3">Müessese/Kurum Adı:</Label>
                                <div
                                    className={
                                        "col-sm-8 form-group" + this.validateClass("tMuesseseAdi")
                                    }
                                >
                                    <input
                                        className="form-control"
                                        type="text"
                                        disabled={
                                            this.state.fieldsDisabled ||
                                            !this.state.memberInfo.uyeCalisiyor ||
                                            !(this.state.memberInfo.uyeTipi === "ECZANE_SAHIBI" ||
                                                this.state.memberInfo.uyeTipi === "ECZANE_SAHIBI_VE_MESUL_MUDUR")
                                        }
                                        name="muesseseAdi"
                                        id="tMuesseseAdi"
                                        maxLength="100"
                                        value={this.state.memberInfo.muesseseAdi || ""}
                                        onChange={(e) =>
                                            this.onChangeMemberUpperCase(
                                                "muesseseAdi",
                                                e.target.value
                                            )
                                        }
                                    />
                                    {this.validateMessage("tMuesseseAdi") !== "" && (
                                        <UncontrolledTooltip
                                            placement="right"
                                            target="tMuesseseAdi"
                                            delay={0}
                                        >
                                            {this.validateMessage("tMuesseseAdi")}
                                        </UncontrolledTooltip>
                                    )}
                                </div>
                            </div>

                            <div className="row">
                                <Label className="col-sm-3">İş Yeri Telefonu:</Label>
                                <div
                                    className={
                                        "col-sm-8 form-group" + this.validateClass("tIsTel")
                                    }
                                >
                                    <input
                                        className="form-control"
                                        type="text"
                                        disabled={
                                            this.state.fieldsDisabled ||
                                            !this.state.memberInfo.uyeCalisiyor ||
                                            !(this.state.memberInfo.uyeTipi === "ECZANE_SAHIBI" ||
                                                this.state.memberInfo.uyeTipi === "ECZANE_SAHIBI_VE_MESUL_MUDUR")
                                        }
                                        name="isTel"
                                        id="tIsTel"
                                        maxLength="10"
                                        value={this.state.memberInfo.isTel || ""}
                                        onChange={(e) =>
                                            this.onChangeMember("isTel", e.target.value)
                                        }
                                    />
                                    {this.validateMessage("tIsTel") !== "" && (
                                        <UncontrolledTooltip
                                            placement="right"
                                            target="tIsTel"
                                            delay={0}
                                        >
                                            {this.validateMessage("tIsTel")}
                                        </UncontrolledTooltip>
                                    )}
                                </div>
                            </div>
                            <div className="row">
                                <Label className="col-sm-3">İş Yeri Adresi: *</Label>
                                <div
                                    className={
                                        "col-sm-8 form-group" + this.validateClass("tWorkAdres")
                                    }
                                >
                                    <TextArea
                                        className="form-control"
                                        type="text"
                                        disabled={
                                            this.state.fieldsDisabled ||
                                            !this.state.memberInfo.uyeCalisiyor ||
                                            !(this.state.memberInfo.uyeTipi === "ECZANE_SAHIBI" ||
                                                this.state.memberInfo.uyeTipi === "ECZANE_SAHIBI_VE_MESUL_MUDUR")
                                        }
                                        name="workAdres"
                                        id="tWorkAdres"
                                        style={{ height: 60, minHeight: 60 }}
                                        value={
                                            this.state.memberInfo.addressList[1] &&
                                            this.state.memberInfo.addressList[1].addressString
                                        }
                                        onChange={(e) =>
                                            this.onChangeAddress(
                                                "addressString",
                                                e.target.value,
                                                1,
                                                "string"
                                            )
                                        }
                                    />
                                    {this.validateMessage("tWorkAdres") !== "" && (
                                        <UncontrolledTooltip
                                            placement="right"
                                            target="tWorkAdres"
                                            delay={0}
                                        >
                                            {this.validateMessage("tWorkAdres")}
                                        </UncontrolledTooltip>
                                    )}
                                </div>
                            </div>
                            <div className="row">
                                <Label className="col-sm-3">İş Yeri İl/İlçe: </Label>
                                <div
                                    className={
                                        "col-sm-4 form-group" + this.validateClass("tWorkAdresCity")
                                    }
                                >
                                    <Select
                                        className="basic-single"
                                        disabled={
                                            this.state.fieldsDisabled ||
                                            !this.state.memberInfo.uyeCalisiyor ||
                                            !(this.state.memberInfo.uyeTipi === "ECZANE_SAHIBI" ||
                                                this.state.memberInfo.uyeTipi === "ECZANE_SAHIBI_VE_MESUL_MUDUR")
                                        }
                                        classNamePrefix="select"
                                        placeholder="İl seçiniz."
                                        isClearable={false}
                                        isSearchable={true}
                                        name="workAdresCity"
                                        id="tWorkAdresCity"
                                        style={{ flex: 0.9 }}
                                        options={this.state.workAdrsCities}
                                        value={workCityValue}
                                        onChange={value =>
                                            this.onChangeAddress("cityId", value, 1, "select")
                                        }

                                    />
                                    {this.validateMessage("tWorkAdresCity") !== "" && (
                                        <UncontrolledTooltip
                                            placement="right"
                                            target="tWorkAdresCity"
                                            delay={0}
                                        >
                                            {this.validateMessage("tWorkAdresCity")}
                                        </UncontrolledTooltip>
                                    )}
                                </div>
                                <div
                                    className={
                                        "col-sm-4 form-group" +
                                        this.validateClass("tWorkAdresCitySub")
                                    }
                                >
                                    <Select
                                        className="basic-single"
                                        disabled={
                                            this.state.fieldsDisabled ||
                                            !this.state.memberInfo.uyeCalisiyor ||
                                            !(this.state.memberInfo.uyeTipi === "ECZANE_SAHIBI" ||
                                                this.state.memberInfo.uyeTipi === "ECZANE_SAHIBI_VE_MESUL_MUDUR")
                                        }
                                        classNamePrefix="select"
                                        placeholder="İlçe seçiniz."
                                        isClearable={false}
                                        isSearchable={true}
                                        name="workAdresCitySub"
                                        id="tWorkAdresCitySub"
                                        style={{ flex: 0.9 }}
                                        options={this.state.workAdrsCitySubdivisions || []}
                                        value={workTownValue || null}
                                        onChange={value =>
                                            this.onChangeAddress("citysubdivisionId", value, 1, "select")
                                        }
                                    />
                                    {this.validateMessage("tWorkAdresCitySub") !== "" &&
                                        !(
                                            this.state.fieldsDisabled ||
                                            !this.state.memberInfo.uyeCalisiyor ||
                                            !(this.state.memberInfo.uyeTipi === "ECZANE_SAHIBI" ||
                                                this.state.memberInfo.uyeTipi === "ECZANE_SAHIBI_VE_MESUL_MUDUR")
                                        ) && (
                                            <UncontrolledTooltip
                                                placement="right"
                                                target="tWorkAdresCitySub"
                                                delay={0}
                                            >
                                                {this.validateMessage("tWorkAdresCitySub")}
                                            </UncontrolledTooltip>
                                        )}


                                </div>
                            </div>

                            <div className="row">
                                <Label className="col-sm-3">Semt: </Label>
                                <div
                                    className={
                                        "col-sm-8 form-group" + this.validateClass("tWorkSemt")
                                    }
                                >
                                    <input
                                        className="form-control"
                                        type="text"
                                        disabled={
                                            this.state.fieldsDisabled ||
                                            !this.state.memberInfo.uyeCalisiyor ||
                                            !(this.state.memberInfo.uyeTipi === "ECZANE_SAHIBI" ||
                                                this.state.memberInfo.uyeTipi === "ECZANE_SAHIBI_VE_MESUL_MUDUR")
                                        }
                                        name="workSemt"
                                        id="tWorkSemt"
                                        maxLength="20"
                                        value={
                                            this.state.memberInfo.addressList[1] &&
                                            this.state.memberInfo.addressList[1].semt
                                        }
                                        onChange={(e) =>
                                            this.onChangeAddress("semt", e.target.value, 1, "string")
                                        }
                                    />
                                    {this.validateMessage("tWorkSemt") !== "" && (
                                        <UncontrolledTooltip
                                            placement="right"
                                            target="tWorkSemt"
                                            delay={0}
                                        >
                                            {this.validateMessage("tWorkSemt")}
                                        </UncontrolledTooltip>
                                    )}
                                </div>
                            </div>
                            <div className="row">
                                <Label className="col-sm-3">
                                    Müessese Ruhsatnamesi Belge No/Tarih:
                                </Label>
                                <div
                                    className={
                                        "col-sm-4 form-group" + this.validateClass("tRuhsatNo")
                                    }
                                >
                                    <input
                                        className="form-control"
                                        type="text"
                                        disabled={
                                            this.state.fieldsDisabled ||
                                            !this.state.memberInfo.uyeCalisiyor ||
                                            !(this.state.memberInfo.uyeTipi === "ECZANE_SAHIBI" ||
                                                this.state.memberInfo.uyeTipi === "ECZANE_SAHIBI_VE_MESUL_MUDUR")
                                        }
                                        name="ruhsatNo"
                                        id="tRuhsatNo"
                                        maxLength="50"
                                        style={{ flex: 1 }}
                                        value={this.state.memberInfo.ruhsatNo || ""}
                                        onChange={(e) =>
                                            this.onChangeMemberUpperCase("ruhsatNo", e.target.value)
                                        }
                                    />
                                    {this.validateMessage("tRuhsatNo") !== "" && (
                                        <UncontrolledTooltip
                                            placement="right"
                                            target="tRuhsatNo"
                                            delay={0}
                                        >
                                            {this.validateMessage("tRuhsatNo")}
                                        </UncontrolledTooltip>
                                    )}
                                </div>
                                <div
                                    className={
                                        "col-sm-4 form-group" + this.validateClass("tRuhsatTarihi")
                                    }
                                >
                                    <DatePicker
                                        {...tRuhsatTarihi}
                                        className="basic-single"
                                        placeholder="Tarih seçiniz."
                                        disabled={
                                            this.state.fieldsDisabled ||
                                            !this.state.memberInfo.uyeCalisiyor ||
                                            !(this.state.memberInfo.uyeTipi === "ECZANE_SAHIBI" ||
                                                this.state.memberInfo.uyeTipi === "ECZANE_SAHIBI_VE_MESUL_MUDUR")
                                        }
                                        classNamePrefix="select"
                                        format="DD.MM.YYYY"
                                        isClearable={true}
                                        isSearchable={true}
                                        name="ruhsatTarihi"
                                        id="tRuhsatTarihi"
                                        style={{ flex: 1 }}
                                        onChange={(date, dateString) =>
                                            this.onChangeDateString("ruhsatTarihi", dateString)
                                        }
                                    />
                                    {this.validateMessage("tRuhsatTarihi") !== "" && (
                                        <UncontrolledTooltip
                                            placement="right"
                                            target="tRuhsatTarihi"
                                            delay={0}
                                        >
                                            {this.validateMessage("tRuhsatTarihi")}
                                        </UncontrolledTooltip>
                                    )}
                                </div>
                            </div>
                            <div className="row">
                                <Label className="col-sm-3">Vergi Dairesi:</Label>
                                <div
                                    className={
                                        "col-sm-8 form-group" +
                                        this.validateClass("tVergiDairesiAd")
                                    }
                                >
                                    <input
                                        className="form-control"
                                        type="text"
                                        disabled={
                                            this.state.fieldsDisabled ||
                                            !this.state.memberInfo.uyeCalisiyor ||
                                            !(this.state.memberInfo.uyeTipi === "ECZANE_SAHIBI" ||
                                                this.state.memberInfo.uyeTipi === "ECZANE_SAHIBI_VE_MESUL_MUDUR")
                                        }
                                        name="vergiDairesiAd"
                                        id="tVergiDairesiAd"
                                        maxLength="50"
                                        value={this.state.memberInfo.vergiDairesiAd || ""}
                                        onChange={(e) =>
                                            this.onChangeMemberUpperCase(
                                                "vergiDairesiAd",
                                                e.target.value
                                            )
                                        }
                                    />
                                    {this.validateMessage("tVergiDairesiAd") !== "" && (
                                        <UncontrolledTooltip
                                            placement="right"
                                            target="tVergiDairesiAd"
                                            delay={0}
                                        >
                                            {this.validateMessage("tVergiDairesiAd")}
                                        </UncontrolledTooltip>
                                    )}
                                </div>
                            </div>

                            <div className="row">
                                <Label className="col-sm-3">Vergi No:</Label>
                                <div
                                    className={
                                        "col-sm-8 form-group" + this.validateClass("tVergiNo")
                                    }
                                >
                                    <input
                                        className="form-control"
                                        type="text"
                                        disabled={
                                            this.state.fieldsDisabled ||
                                            !this.state.memberInfo.uyeCalisiyor ||
                                            !(this.state.memberInfo.uyeTipi === "ECZANE_SAHIBI" ||
                                                this.state.memberInfo.uyeTipi === "ECZANE_SAHIBI_VE_MESUL_MUDUR")
                                        }
                                        name="tVergiNo"
                                        id="tVergiNo"
                                        maxLength="50"
                                        value={this.state.memberInfo.vergiNo || ""}
                                        onChange={(e) =>
                                            this.onChangeMember("vergiNo", e.target.value)
                                        }
                                    />
                                    {this.validateMessage("tVergiNo") !== "" && (
                                        <UncontrolledTooltip
                                            placement="right"
                                            target="tVergiNo"
                                            delay={0}
                                        >
                                            {this.validateMessage("tVergiNo")}
                                        </UncontrolledTooltip>
                                    )}
                                </div>
                            </div>
                        </div>
                        <div className="FormRenk col-sm-12">
                            <span className="form-title">Dosya Yükleme</span>

                            <div className="row">
                                <Label className="col-sm-3">Kayıt Dilekçesi: </Label>
                                <div className="col-sm-8 form-group">
                                    <Uploader2
                                        onInfoChange={this.onChangeMember}
                                        fileName="kayitDilekceFile"
                                        thumbFileName="kayitDilekceThumbFile"
                                        filePathName="kayitDilekcePath"
                                        pathPrefix="kayitDilekce"
                                        memberTCKN={this.state.memberInfo.tcKimlikNo}
                                        filePath={this.state.memberInfo.kayitDilekcePath}
                                        file={this.state.memberInfo.kayitDilekceFile}
                                        thumb={this.state.memberInfo.kayitDilekceThumbFile}
                                        // isDisabled={this.state.fieldsDisabled}
                                        isDeleteBtnDisabled={this.state.deleteBtnDisabled}
                                        isFileAddDisabled={this.state.fileAddDisabled}
                                    />
                                </div>
                            </div>
                            <div className="row">
                                <Label className="col-sm-3">Özgeçmiş: </Label>
                                <div className="col-sm-8 form-group">
                                    <Uploader2
                                        onInfoChange={this.onChangeMember}
                                        fileName="ozgecmisFile"
                                        thumbFileName="ozgecmisThumbFile"
                                        filePathName="ozgecmisPath"
                                        pathPrefix="ozgecmis"
                                        memberTCKN={this.state.memberInfo.tcKimlikNo}
                                        filePath={this.state.memberInfo.ozgecmisPath}
                                        file={this.state.memberInfo.ozgecmisFile}
                                        thumb={this.state.memberInfo.ozgecmisThumbFile}
                                        // isDisabled={this.state.fieldsDisabled}
                                        isDeleteBtnDisabled={this.state.deleteBtnDisabled}
                                        isFileAddDisabled={this.state.fileAddDisabled}
                                    />
                                </div>
                            </div>
                            <div className="row">
                                <Label className="col-sm-3">Nüfus Cüz. Sureti: </Label>
                                <div className="col-sm-8 form-group">
                                    <Uploader2
                                        onInfoChange={this.onChangeMember}
                                        fileName="kimlikCuzdanFile"
                                        thumbFileName="kimlikCuzdanThumbFile"
                                        filePathName="kimlikCuzdanPath"
                                        pathPrefix="kimlik"
                                        memberTCKN={this.state.memberInfo.tcKimlikNo}
                                        filePath={this.state.memberInfo.kimlikCuzdanPath}
                                        file={this.state.memberInfo.kimlikCuzdanFile}
                                        thumb={this.state.memberInfo.kimlikCuzdanThumbFile}
                                        // isDisabled={this.state.fieldsDisabled}
                                        isDeleteBtnDisabled={this.state.deleteBtnDisabled}
                                        isFileAddDisabled={this.state.fileAddDisabled}
                                    />
                                </div>
                            </div>
                            <div className="row">
                                <Label className="col-sm-3">İkametgah Sureti: </Label>
                                <div className="col-sm-8 form-group">
                                    <Uploader2
                                        onInfoChange={this.onChangeMember}
                                        fileName="ikametgahFile"
                                        thumbFileName="ikametgahThumbFile"
                                        filePathName="ikametgahPath"
                                        pathPrefix="ikametgah"
                                        memberTCKN={this.state.memberInfo.tcKimlikNo}
                                        filePath={this.state.memberInfo.ikametgahPath}
                                        file={this.state.memberInfo.ikametgahFile}
                                        thumb={this.state.memberInfo.ikametgahThumbFile}
                                        // isDisabled={this.state.fieldsDisabled}
                                        isDeleteBtnDisabled={this.state.deleteBtnDisabled}
                                        isFileAddDisabled={this.state.fileAddDisabled}
                                    />
                                </div>
                            </div>

                            <div className="row">
                                <Label className="col-sm-3">Diploma Fotokopisi:</Label>
                                <div className="col-sm-8 form-group">
                                    <Uploader2
                                        onInfoChange={this.onChangeMember}
                                        fileName="diplomaFile"
                                        thumbFileName="diplomaThumbFile"
                                        filePathName="diplomaPath"
                                        pathPrefix="diploma"
                                        memberTCKN={this.state.memberInfo.tcKimlikNo}
                                        filePath={this.state.memberInfo.diplomaPath}
                                        file={this.state.memberInfo.diplomaFile}
                                        thumb={this.state.memberInfo.diplomaThumbFile}
                                        // isDisabled={this.state.fieldsDisabled}
                                        isDeleteBtnDisabled={this.state.deleteBtnDisabled}
                                        isFileAddDisabled={this.state.fileAddDisabled}
                                    />
                                </div>
                            </div>

                            <div className="row">
                                <Label className="col-sm-3">İmza Sirküsü: </Label>
                                <div className="col-sm-8 form-group">
                                    <Uploader2
                                        onInfoChange={this.onChangeMember}
                                        fileName="imzaSirküsFile"
                                        thumbFileName="imzaSirküsThumbFile"
                                        filePathName="imzaSirküsPath"
                                        pathPrefix="imzaSirküs"
                                        memberTCKN={this.state.memberInfo.tcKimlikNo}
                                        filePath={this.state.memberInfo.imzaSirküsPath}
                                        file={this.state.memberInfo.imzaSirküsFile}
                                        thumb={this.state.memberInfo.imzaSirküsThumbFile}
                                        // isDisabled={this.state.fieldsDisabled}
                                        isDeleteBtnDisabled={this.state.deleteBtnDisabled}
                                        isFileAddDisabled={this.state.fileAddDisabled}
                                    />
                                </div>
                            </div>
                            <div className="row">
                                <Label className="col-sm-3">Adli Sicil Belgesi: </Label>
                                <div className="col-sm-8 form-group">
                                    <Uploader2
                                        onInfoChange={this.onChangeMember}
                                        fileName="adliSicilFile"
                                        thumbFileName="adliSicilThumbFile"
                                        filePathName="adliSicilPath"
                                        pathPrefix="adlisicil"
                                        memberTCKN={this.state.memberInfo.tcKimlikNo}
                                        filePath={this.state.memberInfo.adliSicilPath}
                                        file={this.state.memberInfo.adliSicilFile}
                                        thumb={this.state.memberInfo.adliSicilThumbFile}
                                        // isDisabled={this.state.fieldsDisabled}
                                        isDeleteBtnDisabled={this.state.deleteBtnDisabled}
                                        isFileAddDisabled={this.state.fileAddDisabled}
                                    />
                                </div>
                            </div>

                            <div className="row">
                                <Label className="col-sm-3">Fotoğraf: </Label>
                                <div className="col-sm-8 form-group">
                                    <Uploader2
                                        onInfoChange={this.onChangeMember}
                                        fileName="fotoFile"
                                        thumbFileName="fotoThumbFile"
                                        filePathName="fotoPath"
                                        pathPrefix="foto"
                                        memberTCKN={this.state.memberInfo.tcKimlikNo}
                                        filePath={this.state.memberInfo.fotoPath}
                                        file={this.state.memberInfo.fotoFile}
                                        thumb={this.state.memberInfo.fotoThumbFile}
                                        // isDisabled={this.state.fieldsDisabled}
                                        isDeleteBtnDisabled={this.state.deleteBtnDisabled}
                                        isFileAddDisabled={this.state.fileAddDisabled}
                                    />
                                </div>
                            </div>

                            {this.state.memberInfo.calismaBelgeli && (
                                <div className="row">
                                    <Label className="col-sm-3">Çalışma Belgesi: </Label>
                                    <div className="col-sm-8 form-group">
                                        <Uploader2
                                            onInfoChange={this.onChangeMember}
                                            fileName="calismaBelgesiFile"
                                            thumbFileName="calismaBelgesiThumbFile"
                                            filePathName="calismaBelgesiPath"
                                            pathPrefix="calismaBelgesi"
                                            memberTCKN={this.state.memberInfo.tcKimlikNo}
                                            filePath={this.state.memberInfo.calismaBelgesiPath}
                                            file={this.state.memberInfo.calismaBelgesiFile}
                                            thumb={this.state.memberInfo.calismaBelgesiThumbFile}
                                            // isDisabled={this.state.fieldsDisabled}
                                            isDeleteBtnDisabled={this.state.deleteBtnDisabled}
                                            isFileAddDisabled={this.state.fileAddDisabled}
                                        />
                                    </div>
                                </div>
                            )}
                        </div>

                        {this.state.mode === "review" ? (
                            <div className="row">
                                <Label className="col-sm-3">Reddedilme Nedeni: </Label>
                                <div
                                    className={
                                        "col-sm-8 form-group" +
                                        this.validateClass("tBasvuruReddedilmeSebebi")
                                    }
                                >
                                    <TextArea
                                        className="form-control"
                                        type="text"
                                        name="basvuruReddedilmeSebebi"
                                        id="tBasvuruReddedilmeSebebi"
                                        maxLength="255"
                                        value={this.state.memberInfo.basvuruReddedilmeSebebi}
                                        onChange={(e) =>
                                            this.onChangeMemberUpperCase(
                                                "basvuruReddedilmeSebebi",
                                                e.target.value
                                            )
                                        }
                                    />
                                    {this.validateMessage("tBasvuruReddedilmeSebebi") !== "" && (
                                        <UncontrolledTooltip
                                            placement="right"
                                            target="tBasvuruReddedilmeSebebi"
                                            delay={0}
                                        >
                                            {this.validateMessage("tBasvuruReddedilmeSebebi")}
                                        </UncontrolledTooltip>
                                    )}
                                </div>
                            </div>
                        ) : (
                            ""
                        )}
                    </Form>
                    {
                        this.state.mode === "review" ? (
                            <div className="row">
                                <div className="col">
                                    {this.state.memberInfo.basvuruDurumu === "UYELIK_BILGILERININ_KONTROLU_BEKLENIYOR" &&
                                        this.RightExists("RIGHT_MEMBER_UPDATE_BASVURU") && (
                                            <button
                                                onClick={() => this.handleApproveSekreter()}
                                                className="sekreter-button"
                                            >
                                                ODA YETKİLİSİNE GÖNDER
                                            </button>
                                        )}
                                </div>

                                <div className="col">

                                    {
                                        this.state.memberInfo.basvuruDurumu === "ODA_YETKILISI_ONAYI_BEKLENIYOR" &&
                                        this.RightExists("RIGHT_MEMBER_UPDATE_BASKAN") && (
                                            <button
                                                onClick={() => this.handleApproveBaskan()}
                                                className="custom-button approve-button"
                                            >
                                                ONAYLA
                                            </button>
                                        )}
                                </div>

                                <div className="col">
                                    {this.state.memberInfo.basvuruDurumu === "ODA_YETKILISI_ONAYI_BEKLENIYOR" &&
                                        this.RightExists("RIGHT_MEMBER_UPDATE_BASKAN") && (
                                            <button
                                                onClick={() => this.handleReject()}
                                                className="custom-button reject-button"
                                            >
                                                REDDET
                                            </button>
                                        )}
                                </div>

                                <div className="col">
                                    {this.state.memberInfo.basvuruDurumu !== "ONAYLANDI" && (
                                        <button
                                            onClick={() => this.saveMember("IADE")}
                                            className="custom-button return-button"
                                        >
                                            İADE ET
                                        </button>
                                    )}
                                </div>
                            </div>
                        ) : (
                            <div className="save-button-container">
                                <button
                                    onClick={() => {
                                        this.saveMember("KAYDET");
                                    }}
                                    className="member-save-button"
                                    disabled={
                                        this.state.isLoading || this.state.memberInfo.isTransferred
                                    }
                                >
                                    KAYDET
                                </button>
                            </div>
                        )
                    }
                </div>
                <Modal
                    isOpen={this.state.inActivateMemberModal}
                    size="lg"
                    className="ust"
                >
                    <ModalHeader
                        toggle={() => this.setState({ inActivateMemberModal: false })}
                    >
                        Uyarı
                    </ModalHeader>
                    <ModalBody
                        style={{
                            "max-height": "calc(100vh - 210px)",
                            "overflow-y": "auto",
                        }}
                    >
                        <InActivateMemberModal
                            close={() => this.setState({ inActivateMemberModal: false })}
                            inActivate={() => this.onChangeCheck("uyelikAktif", false)}
                            message={
                                "Üyenin Oda İlişiği Kesilir ve 'KAYDET' e Tıklanırsa, İlişik Tekrar Aktif Hale Getirilemez! Devam Etmek İstiyor musunuz?"
                            }
                        />
                    </ModalBody>
                </Modal>
            </div>
        );
    }
}

export default MemberForm;



// WEBPACK FOOTER //
// ./src/page/memberList/MemberForm.js